const cabinetOrigin = process.env.VUE_APP_CABINET_ORIGIN.toUpperCase()

export default {
	//login home page
	loginHeader: {
		contactUs: 'Contact us',
	},
	loginPage: {
		instructionstitle1: "We've got you covered!",
		instructionstitle2: 'Solutions for every',
		instructionstitle3: 'need you have',
		options1f: 'Access your',
		options1l: 'Cabinet',
		options2f: 'Enter your',
		options2l: 'IB portal',
		options3f: 'Explore',
		options3l: 'Prop reports',
		termsAndConditions: 'Terms and Conditions',
		privacyPolicy: 'Privacy Policy',
		amlPolicy: 'AML Policy',
		refundPolicy: 'Refund Policy',
		riskDisclosure: 'Risk Disclosure',
		complaintsProcedure: 'Complaints Procedure',
		cookiePolicy: 'Cookie Policy',
		userError:
			'The entered password is incorrect, please review and try again.',
		userErrorTwo:
			'Entered email  is not registered. Please review and try again.',
		enterCodeBelow:
			'Enter the code provided by your authentication app in the boxes below.',
		enterYourCode: 'Enter your 2FA code',
		authCode: 'Authentication code',
		loginMobile: 'Login to your account',
		loginOr: 'Or login with your credentials:',
	},
	modalIBAccountVerification: {
		title: 'You already have an Introducing Broker account with Tradeview',
		description: 'Where would you like to log in?',
		radioOtp1: 'IB Portal',
		radioOtp2: 'Client Cabinet',
	},
	modalCantApplyAsIBIsNotIndividual: {
		title: 'Digital IB application not supported',
		description:
			'This online process is currently available only for individual IB accounts. Since you’re applying under a different account category, please contact us for assistance.',
	},
	modalCantApplyAsIBLTD: {
		title: 'Entity not eligible for IB account',
		description:
			'The entity linked to your Tradeview account does not support the creation of an Introducing Broker (IB) account. Please contact us for assistance:',
	},

	wellcomeComponent: {
		title: 'Thanks for your interest!',
		titlesub: "Let's begin your application",
		subTitle:
			"You're about to engage in our process to gather the information needed to set up your account and verify your identity.",
		before: 'Before starting, prepare the following documents:',
		government: 'Government-issued photo ID',
		proof: 'Proof of residence',
		signature: 'Digital signature',
		agreeMarketingDistribute:
			'I/We agree to be included in our marketing distribution list',
		agree:
			'* I agree to let Tradeview Ltd. electronically verify my identity by providing my personal information, including identity documents. This information will be shared with a trusted identity verification service provider to confirm its accuracy and match it with the data they hold or obtain from other reliable sources.',
		agreeLATAM:
			'* I agree to let Tradeview Financial Markets S.A.C. electronically verify my identity by providing my personal information, including identity documents. This information will be shared with a trusted identity verification service provider to confirm its accuracy and match it with the data they hold or obtain from other reliable sources.',
		btnContinue: 'Continue',
		btnGoBack: 'Go Back',
		btnConfirm: 'Confirm',
		checkError: 'Check the box to agree to the information treatment.',
	},

	loginBox: {
		title: 'Login to your account',
		logInGoogle: 'Continue with Google',
		logInFacebook: 'Continue with Facebook',
		or: 'Or login with your credentials:',
		email: 'Email',
		placeholderEmail: 'Enter your email',
		placeholderPassword: 'Enter your password',
		password: 'Enter your password',
		submit: 'Continue',
		forgot: 'Forgot password?',
		doNotAccount: "Don't have an account?",
		signUp: 'Sign Up',
		tryFreeDemo: 'Try a Free Demo',
		remember: 'Remember me',
		emailError: 'Please enter your email',
		passwordError: 'Please enter your password',
		passwordToEmail: 'Please check your email.',
		passwordToEmailDesc:
			'We’ve sent you a temporary password to reset your account.',
	},

	forgotPage: {
		instructionstitle1: 'Save time and effort!',
		instructionstitle2: 'A platform for every',
		instructionstitle3: 'need you have',
		options1f: 'Regulated',
		options1l: 'and safe',
		options2f: 'Personalized',
		options2l: 'assistance',
		options3f: 'Unmatched',
		options3l: 'liquidity',
	},

	forgotBox: {
		title: 'Reset your password',
		email: 'Email',
		text1: 'Enter your registered email below and we’ll send',
		text2: 'you the instructions to reset your password.',
		placeholderEmail: 'Enter your email',
		badFormatEmail: `Please make sure the entered mail is in a valid format. e.g. username@mail.com`,
		badEmail: 'Please enter your registered email',
		wrongEmail: 'Entered email is not registered. Please review and try again.',
		continue: 'Continue',
		limitExceeded: 'Limit exceeded',
		requiredField: 'This field is required',
		goBackLogIn: 'Go back to log in',
	},

	verifiCode: {
		title: 'Verify your email address',
		text1: 'We sent you an activation code to your registered email.',
		text2: 'Enter below the one time code we sent to your registered email',
		label1: 'Verification code',
		label2: 'E.g. 123456',
		label3: 'Entered code is invalid. Please review and try again.',
		submit: 'Submit',
		text3: "Didn't receive any code?",
		text4: 'Re-send the code',
		alert1: 'A one-time code was sent to ',
		alert2: "We can't resend your code right now. Please try again.",
		alert3: 'Incorrect verification code, please try again.',
		error:
			'Something went wrong. Please contact our representatives at {contactInfo}',
	},

	setPassword: {
		title: 'Set your new password',
		text1: 'Please enter your new password, ensuring that ',
		text2: 'it differs from the passwords previously used.',
		label1: 'New password',
		label2:
			'Password must be at least 8 characters and include at least one lowercase, one uppercase, one number, and one special character.',
		label3: 'Confirm password',
		placeholder1: 'Enter your new password',
		placeholder2: 'Confirm your new password',
		error1:
			'Password must be at least 8 characters and include at least one lowercase, one uppercase, one number, and one special character.',
		error2: "Entered passwords don't match. Please double-check and try again",
		description:
			'We sent you an activation code to your registered email. Review your inbox and enter it below. After confirming the activation code, enter your new password, ensuring that it differs from the passwords previously used.',
	},

	setPasswordSuccess: {
		title1: 'Your password has been ',
		title2: 'successfully reset!',
		login: 'Login',
	},

	consoleHeader: {
		account: 'Account #',
		balance: 'Balance',
		equity: 'Equity',
		free: 'Free Margin',
		margin: 'Margin Level',
		status: 'Status',
		hello: 'Hello',
		logout: 'Log out',
		confirm: 'Confirm',
		outModal: 'Are you sure you want to logout?',
		yes: 'Yes',
		not: 'Not',
		settings: 'Settings',
		areYouDone: 'Are you done?',
		areYouSure:
			'Are you sure you want to log out? Any unsaved changes will be lost.',
		yesLogOut: 'Yes, log out',
	},

	// Platforms page
	platforms: {
		description:
			"Enjoy the ease of using important trading tools and account info on your device, giving you control whether you're on the go or at your desk. Select the way you want to work and download the software/app that best suits you.",
		mainTitle: 'How do you want to trade?',
		metatrader4: {
			desc1: 'User-friendly and customizable interface',
			desc2: 'Rapid execution speeds for efficient trading',
			desc3: 'Effortless order placement',
			desc4: 'Effective position management',
			desc5: 'Visualization of price movements for informed decisions',
		},
		metatrader5: {
			desc1: 'Key trading tools and account info on your device',
			desc2: 'Alerts so as not to miss important events in the markets',
			desc3: 'Support for automated trading',
			desc4: 'Over 80 built-in indicators and analytical tools',
			desc5: 'Advanced tools for enhanced trading strategies',
		},
		cTrader: {
			desc1: 'Fast and user-friendly trading experience',
			desc2: 'Direct access to currency markets',
			desc3: 'Easy order placement',
			desc4: 'Market depth visibility for informed decisions',
			desc5: 'Advanced technology for enhanced trading',
		},
		sterling: {
			desc1: 'Customizable layouts and shortcut keys',
			desc2: 'Level I and Level II real-time market information',
			desc3: 'Positions and profit/loss real-time monitoring',
			desc4: 'Tailorable ticker watchlist featuring 60+ data points per symbol',
			desc5: 'Over 90 studies and indicators charting package',
		},
		lightspeed: {
			desc1: 'Multiple locate sources with varied prices',
			desc2: 'Customizable orders based on pre-configured settings',
			desc3: 'Options order forms for complex strategies',
			desc4: 'Customizable watchlists and hot keys for quick order entry',
			desc5: 'Comprehensive risk management settings',
		},

		takion: {
			desc1: 'Multiple chart types, timeframes, and technical indicators',
			desc2: 'Direct trading with market access for efficiency',
			desc3: 'Real-time market scanners and news updates',
			desc4: 'Level II real-time and sales data',
			desc5: 'Layers and workspaces for seamless trading operations',
		},

		das: {
			desc1: 'Advanced order types and real-time charting',
			desc2: 'Multi-account management',
			desc3: 'Customizable hot keys for quick order entry',
			desc4: 'Low-latency order validation to major US Exchanges',
			desc5: 'Real-time market data access',
		},

		api: {
			desc1: 'Direct and high speed connectivity to our trading servers',
			desc2: 'Fast execution and platform customization',
			desc3: 'Full control over the data submited and received',
			desc4: 'Various market and limit order options',
			desc5: 'Flexibility for your trading strategy',
		},
		cqg: {
			desc1: 'Easy to use trading interfaces',
			desc2: 'Essential charts and analytics',
			desc3: 'Real-time data in a variety of quote styles including heatmaps',
			desc4: 'Orders and positions managemen',
			desc5: 'RSS News',
		},
		thanksForYourInterest: 'Thanks for your interest',
		weWillContactYou:
			'A tradeview representative will get in touch with you shortly to help you set up your new demo account.',
		createAccountToDownload: 'Create an account to download this platform',
		createAccount: 'Create an account',
		platformNotCovered:
			'This platform is not covered by your existing account. To install and use it, please create an account dedicated to this market and platform.',
		btn_downd: 'Download',
		btn_launch: 'Launch web version',
		btn_request: 'Download upon request',
		okay: 'Okay',
		continue: 'Continue',
		requestAccount: 'Request an account',
		disabledOptionAlert:
			"We're unable to initiate your download. Please wait 10 seconds between download attempts and try again.",
		modal_reminder: {
			title: 'Reminder',
			descript1: 'Your download is in progress! To access',
			descript2:
				"use the credentials we've sent you via email. If you haven't requested an account for this platform yet, you can do so now or at any time. Remember,",
			descript3: 'an account is required for access.',
			descript1sub: 'To access',
			descript2sub:
				"use the credentials we've sent you via email. If you haven't requested an account for this platform yet, you can do so now or at any time. Remember,",
			descript3sub: 'an account is required for access.',
		},
		modal_send: {
			title: 'Your request has been sent',
			descript:
				"Thank you for your interest! We'll be in touch with you shortly to assist you with setting up the selected platform.",
		},
		acessPlatforms:
			"You'll need an account to access these platforms, you may request one",
		acessPlatformsContinue: '',
		webVersionModal: 'Launch the web version',
		toAccess:
			"To MT5, use the credentials we've sent you via email. If you haven't requested an account for this platform yet, you can do so now or at any time. Remember, an account is required for access.",
		selectTypeAccount:
			'Select the type of account you want to use to launch the web version:',
		live: 'Live',
		demo: 'Demo',
		launch: 'Launch',
	},

	//History page
	history: {
		titleH: 'Your trading history',
		periodTimeL: 'Period of time',
		periodTimeP: 'All history',
		typeL: 'Type',
		typeP: 'Select type',
		platformL: 'Platform',
		platformP: 'Select a platform',
		accountL: 'Trading account',
		accountP: 'Account number',
		fromL: 'From',
		fromP: 'mm/dd/yyyy',
		toL: 'To',
		toP: 'mm/dd/yyyy',
		clearBtn: 'Clear',
		exportBtn: 'Export',
		getBtn: 'Apply filter',
		optionsAccounts: 'Select your trading account',
		infoAlertD: 'Select an account to view its movements here',
		noHistoryYet1: 'The selected filters for the account',
		noHistoryYet2: 'does not have any history yet',
		platformAlertD:
			' Please note: Only accounts of MT4, MT5, and cTrader platforms will be displayed in the filter and table below. For accounts on other platforms, you can access their trading history within their respective platforms.',
		accountTypeH: 'Account type',
		accountTypeP: 'Select an account type',
		alertExport: 'Your information has been successfully exported',
		btnFilter: 'Filters',
		alertPlatforMobile:
			'Note: Only MT4, MT5, and cTrader accounts are shown below. You may access trading history for other platforms within the respective platforms.',
		modalHeader: 'Are you sure you want to leave?',
		modalDescription:
			'Please note that if you leave now, any progress you’ve made will not be saved. To complete this process later, you’ll need to start over. ',
		btnModalCancel: 'Cancel',
		btnModalYes: "Yes, I'm sure",
		filterbyactivity: 'Filter by activity type',
		accountTooltip:
			'The account number associated with the movement. In the case of transfers, the icon',
		accountTooltip2:
			'represents transfers that entered your consulted account, and',
		accountTooltip3: 'transfers that exited your account.',
		accountTooltipIn:
			'A transfer that entered your consulted account from the source account listed in this column.',
		accountTooltipOut:
			'A transfer that exited your consulted account and was sent to the destination account listed in this column.',
	},

	// Withdraw page
	withdraw: {
		sourceAccount: 'Source account',
		currency: 'Currency',
		currencyType: 'Currency type',
		details: 'Beneficiary Bank Details',
		beneficiaryDetails: 'Beneficiary bank details',
		swiftt: 'Swift',
		branch: 'Branch Name',
		branchCode: 'Branch Name',
		enterbranch: 'Enter your branch code',
		province: 'Province',
		city: 'City',
		bank: 'DBS Bank',
		bankK: 'Bank',
		bankTransfer: 'Select a bank for your transfer',
		withdrawFunds: 'Withdraw your funds',
		withdrawalMethod: 'Withdrawal method',
		withdrawalAmmount: 'Withdrawable amount',
		keepInMind: 'Keep in mind:',
		withdrawalCalendar:
			'Introducing brokers are limited to two withdrawals per calendar a month, with a minimum withdrawal amount of $100 US or equivalent in the base currency. Additional withdrawals within the same calendar month will be charged a $50 processing fee.',
		withdrawalMustMatchDeposit:
			'The withdrawal method selected must match the deposit method. For credit card and digital wallet deposits, withdrawal amounts cannot exceed the original deposit.',
		beneficiaryName: 'Beneficiary name',
		beneficiaryAccount: 'Beneficiary account',
		bankAddress: 'Bank address',
		enterBankAddress: 'Enter your bank address',
		enterBeneficiaryName: 'Enter your beneficiary name',
		beneficiaryAddress: 'Beneficiary address',
		enterBeneficiaryAddress: 'Enter your beneficiary address',
		enterYourAddress: 'Enter your address',
		accountNumber: 'Account number',
		iban: '(IBAN)',
		aliasiban: '(If the account is held ouside the UK- optional)',
		enterAccountNumber: 'Enter your account number',
		bankName: 'Bank name',
		enterBankName: 'Enter your bank name',
		swiftCode: 'Swift code',
		enterSwiftCode: "Enter your bank's swift code",
		enteryourSwiftCode: 'Enter your swift code',
		aliasSwiftCode: ' (If the account is held outside UK- optional)',
		abaNumber: 'ABA number',
		enterAbaNumber: 'Enter your banks ABA number',
		aliasAbaNumber: '(For US domestic -optional)',
		sortCodeClabe: 'Sort code/CLABE',
		enterSortCodeClabe: 'Enter your sort code/CLABE',
		referenceNumber: 'Reference number',
		enterReferenceNumber: 'Enter your reference number',
		associatedEmail: 'Associated email account',
		associatedEmailLabel: 'Associated email',
		enterAssociatedEmailAccount: 'Enter your associated email',
		doYouNeedIntermediary: 'Do you need an intermediary bank?',
		selectAnOption: 'Select an option',
		pleaseSelectAnOption: 'Please select an option',
		enterCashAmount: 'Enter a cash amount',
		helperCashTransfer:
			'Min $10 USD. Transfers over 10K require manual review.',
		intermediaryBank: 'Intermediary bank details',
		intermediaryBankk: 'Intermediary bank',
		ifNeeded: '(If needed)',
		intermediaryBankName: 'Intermediary bank name',
		banescoAccountName: 'Account name',
		enterAccountName: 'Enter your account name',
		clabe: 'CLABE',
		clabealias: '(Account number)',
		enterclabe: 'Enter your CLABE',
		pesosAccount: 'Pesos account number',
		enterIntermediaryBankName: 'Enter your intermediary bank name',
		intermediaryBankAddress: 'Intermediary bank address',
		enterintermediaryBankAddress: 'Enter your intermediary bank address',
		ibanNumber: 'IBAN number',
		enterIbanNumber: 'Enter your IBAN number',
		withdrawalCompleted: 'Your withdrawal has been completed!',
		withdrawalIsComplet: 'Withdrawal under review',
		withdrawalIsCompletDescription:
			'Your withdrawal is now under review. Our team will reach out to you via email once the withdrawal process its done.',
		withdrawalCompletedDescription:
			'Your funds will be available in your destination account shortly. The processing time depends on the withdrawal method you have selected.',
		withdrawNotCompleted: 'Your withdrawal has not been completed',
		withdrawNotCompletedDescription:
			'We encountered an issue while processing your withdrawal. Please verify your withdrawal information and try again. If the problem continues,',
		contactUs: 'contact us.',
		goToMyAccount: 'Go to my account',
		creditCardDetails: 'Credit card details',
		important: 'Important:',
		withdrawalsExceeding:
			'Withdrawals exceeding your initial deposit amount cannot be processed via credit card. You are only eligible to withdraw the same amount as your initial deposit using this method. To withdraw profits, please use an alternative withdrawal method.',
		creditCardLastDigits: "Credit card's last 4 digits",
		enterCreditCardLastDigits: 'Enter the last 4 digits of your credit card',
		netellerAccountDetails: 'Neteller account details',
		netellerComission:
			'2% on deposits and on withdrawals - fees waived if funds are kept for 3 months or longer OR you meet the minimum lot requirement (contact account manager for assistance with the lot calulation)',
		netellerComissionMena:
			'We would like to inform you that due to increasing costs associated with Neteller, we will charge a fee of 1% on all deposits and withdrawals made via Neteller. Fees can be waived in certain circumstances after a review of your account with your Tradeview representative.',
		skrillAccountDetails: 'Skrill account details',
		upholdAccountDetails: 'Uphold account details',
		bitwalletAccountDetails: 'Bitwallet account details',
		interacAccountDetails: 'Interac e-Transfer account details',
		interacHelpMsg: '*Trade-mark of Interact Corp. Used Under License',
		upholdComission:
			"If sending to Uphold account: No Fee. If sending to other Crypto Wallet: TV doesn't charge fees but Uphold charges following fees: Exchange Fee (1.05%), Network Fee (0.0003 BTC), Withdrawal Fee (0.0004 BTC).",
		bitPayTitle: 'BitPay details',
		destinationAccount: 'Destination account',
		bitPayCommision:
			'Crypto processor charges following fees: Exchange Fee (1.05%), Network Fee (0.0003 BTC), Withdrawal Fee (0.0003 BTC)',
		needYourAuth: 'We need your authorization:',
		confirmThoughtEmail:
			'After submitting this withdrawal request, you will need to confirm it through the email registered in your account.',
		wallet: 'Wallet',
		enterYourWallet: 'Enter your wallet',
		enteryourEmailAccount: 'Enter your email',
		sticPayAccountDetails: 'SticPay account details',
		voletAccountDetails: 'Volet account details',
		interacAccountDetails: 'Interac e-Transfer account details',
		fasapayAccountDetails: 'Fasapay account details',
		searchABank: 'Search a bank',
		searchAnAccount: 'Search an account',
		ibanIfApplicable: '(IBAN if applicable)',
		beneficiaryBankName: 'Beneficiary bank name',
		enterBeneficiaryBankName: 'Beneficiary bank name',
		enterYourProvince: 'Enter your province',
		enterYourCity: 'Enter your city',
		unionPayDetails: 'UnionPay details',
		jpayDetails: 'JPay account details',
		jpayAccountDetails: 'JPay account details',
		walletAndCrypto: 'Wallet and cryptocurrency',
		walletAndCryptoAlert:
			'When making a withdrawal using cryptocurrencies there is a conversion fee of 0.7%.',
		crypto: 'Cryptocurrency',
		selectCrypto: 'Select a cryptocurrency',
		tag: 'Tag',
		enter: 'Enter',
		cryptocurrency: 'cryptocurrency',
		enterCryptocurrency: 'Enter cryptocurrency',
		otherCurrency: 'Other cryptocurrency',
		enterOtherCurrency: 'Enter other cryptocurrency',
		areYouSure: 'Are you sure you want to leave?',
		ifYouLeaveNow:
			'Please note that if you leave now, any progress you’ve made will not be saved. To complete this process later, you’ll need to start over. ',
		noStay: 'No, stay',
		yesLeave: 'Yes, leave',
		requestSubmited: 'Your request has been submited!',
		reviewEmail: 'Please review your registered email.',
		unsuccessfulWithdraw: 'Your withdrawal has not been completed',
		reviewAgain:
			'Please review your withdrawal information and try again. If the issue continues happening, ',
		amountTryAgain:
			'Amount exceeds the transferable amount available. Try again.',
		amountTryAgainWithdraw:
			'Amount exceeds the withdrawable amount available. Try again.',
		minimunAmount: 'The minimum withdrawal for this method is $10 USD.',
		minimunAmount100: 'The minimum withdrawal for this method is $100 USD.',
		minimunAmount0:
			'The minimum withdrawal for this method is example 0,00001 BTC.',
		invalidEmail: 'Invalid email format',
		invalidAccountNumber: 'Invalid account number format',
		noAvailableOptions: 'No available options',
		closeModal:
			"Please note if you choose to leave now, any progress made won’t be saved. If you plan to withdraw your funds later, you'll need to start over.",
		successWithdraw:
			'Great news! Your funds will be available in your destination account shortly. The processing time may vary depending on the withdrawal method you selected.',
		fundCreditCard: 'Fund with credit card',
		selectMethod:
			'Withdrawal methods refer to the options available for withdrawing funds from your account. You can withdraw to your bank account, your credit card, your digital wallet, or your crypto wallet.',
		invalidCreditCardDigits: 'Invalid card digits',
		phone: 'Phone',
		enterYourPhone: 'Enter your phone',
		invalidPhone: 'Invalid phone format',
		modalPreferences: "Don't ask again for the current login",
		bankFee: '$35 USD',
		bankBranch: 'Bank branch',
		enterBankBranch: 'Enter your bank branch',
		branchProvince: 'Branch province',
		enterBranchProvince: 'Enter your branch province',
		BranchCity: 'Branch city',
		enterBranchCity: 'Enter your branch city',
	},

	//Account Activity page
	accountActivity: {
		title: 'Account Activity',
		from: 'From',
		to: 'To',
		type: 'Type',
		platform: 'Trading instrument',
		placeholderAccount: 'Trading account',
		account: 'Trading account',
		get: 'Get',
		row: 'Rows for page',
		download: 'Download Report',
		back: 'Back',
		confirm: 'Confirm',
		close: 'Close',
		error: 'Error! There cannot be empty fields',
		errorTwo: 'Error! you must select the field type.',
		activityid: 'Activity ID ',
		platfomr: 'Platform',
		date: 'Date / Time',
		activity: 'Activity',
		profit: 'Profit/Loss',
		timeSegmentation: 'Time Segmentation',
		timeFrame: 'Select a time frame',
		selectType: 'Select type',
		selectMarket: 'Select market',
		tradingAccount: 'Select your trading account',
		segmentation: 'Time segmentation',
		segmentationPlaceholder: 'Select a time frame',
		platformPlaceholder: 'Select a platform',
		alert: 'Your information has been successfully exported',
		infoYet: 'The filters you chose yielded no results. Please try again.',
	},

	//tradingHistory
	tradingHistory: {
		title: 'Trading History',
		from: 'From',
		to: 'To',
		type: 'Type',
		platform: 'Platform',
		placeholderAccount: 'Trading account',
		account: 'Account',
		get: 'Get',
		row: 'Rows for page',
		download: 'Download Report',
		back: 'Back',
		confirm: 'Confirm',
		close: 'Close',
		error: 'Error! There cannot be empty fields',
		errorTwo: 'Error! you must select the field type.',
		deal: 'Deal',
		entryTime: 'Entry Time',
		typr: 'Type',
		simbol: 'Symbol',
		volume: 'Volume',
		entryPrice: 'Entry Price',
		sl: 'S/L',
		tp: 'T/P',
		exitTime: 'Exit Time',
		exitPrice: 'Exit Price',
		commision: 'Commision',
		bankFee: 'Bank fee',
		swap: 'Swap',
		profit: 'Profit/Loss',
		dateFrom: 'yyyy/mm/dd',
		dateTo: 'yyyy/mm/dd',
		openingTime: 'Opening time',
		openingPrice: 'Opening price',
		stopLoss: 'Stop loss',
		takeProfit: 'Take profit',
		closingTime: 'Closing time',
		closingPrice: 'Closing price',
		comission: 'Comission',
		time: 'Time',
	},

	//Transfer page
	transfer: {
		mainTitle: 'Transfer your funds',
		isBackValidation:
			'Our team must review your transfer for approval. This may take up to 24 hours of the next business day.',
		pleaseNote:
			'Please note: transfers are only permitted between accounts owned by the same user.',
		mena: {
			consentCheck:
				'By checking the checkbox I understand that I have requested funds to be transferred from one Tradeview Ltd. account to another of my own Tradeview Ltd accounts',
		},
		ltd: {
			consentCheck:
				'By checking the checkbox I understand that I have requested funds to be transferred from one Tradeview Ltd. account to another of my own Tradeview Ltd accounts',
		},
		latam: {
			consentCheck:
				'By checking the box I understand that I have requested funds to be transferred from one Tradeview Financial Markets S.A.C. account to another of my own Tradeview Financial Markets S.A.C.accounts',
		},
		markConsentCheck:
			'You need to mark the acknowledgment checkbox to continue. Please do it.',
		transferAmount: 'Transferable amount',
		transferCompleted: 'Your transfer is complete',
		transferReview: 'Transfer under review',
		transferInCompleted: 'Your transfer has not been completed',
		transferInCompletedDescription:
			'We encountered an issue while processing your transfer. Please verify your account information and try again. If the problem continues,',
		transferDescription:
			'Great news! Your funds will be available in your destination account shortly.',
		transferDescriptionReview:
			'Your transfer is now under review. Our team will reach out to you email once the transfer process its done.',
		destinationAccount: 'Destination account',
		minimunAmount: 'The minimum transferable amount for this method is $10.',
	},

	//Accounts
	accounts: {
		refresh: 'Refresh balances',
		liveAccounts: 'Live accounts',
		demoAccounts: 'Demo accounts',

		createLive: '+ Create a New Live Account',
		createDemo: '+ Create a New Demo Account',
		refresh: 'Refresh balances',
		createAccount: 'Create a new account',
		createDemoAccount: 'Create a new demo account',
		createLiveAccount: 'Create a new live account',
		livee: 'Live',
		demoo: 'Demo',
		yourBalance: 'Your balance',
		equityy: 'Equity',
		marginLevel: 'Margin level',
		freeMargin: 'Free margin',
		statuss: 'Status',
		leveragee: 'Leverage',
		credit: 'Credit',
		phone: 'Phone',
		selectLeverage: 'Select a leverage',
		noLiveAccount:
			"You don't have a live acount. Choose one that fit your needs and start trading now.",
		noDemoAccount:
			"You don't have a demo account. Choose one that fits your needs and start practicing.",
		tradingInstrument: 'Trading market',
		tradingMethodTooltip:
			"Trading markets refers to the various market types you can engage with. Often referred to as securities, these encompass commodities futures, stocks, CFDs, currencies, metals, and much more. <br><br> Not sure which market to choose? You can review them <a href='https://www.tvmarkets.com/trading/markets' target='_blank'>here</a>",
		here: 'here',
		selectAMarket: 'Select a market',
		platform: 'Platform',
		selectAPlatform: 'Select a platform',
		cashAmount: 'Cash amount',
		selectCashAmount: 'Select a cash amount',
		accountType: 'Account type',
		selectAnAccount: 'Select an account type',
		currencyy: 'Currency type',
		selectACurrency: 'Select a currency',
		platformTooltip:
			"A platform is the software you'll get to use to execute trades on your account. <br><br> Not sure which platform to choose? You can review them <a href='https://www.tvmarkets.com/trading/platforms' target='_blank'>here</a>",
		accountTypeTooltip:
			'The account type allows you to select the trading conditions (leverage, spreads, commissions) for your account.',
		accountTypeTooltip2: 'You can review the conditions for each account type',
		applicationCompleted: 'Your application has been completed!',
		applicationCompletedDescription:
			'Your live account application is now under review and will be verified shortly. One of our advisors will reach out to you if additional documentation is needed.',
		applicationError: "Your application wasn't submited",
		applicationErrorDescription:
			'An error occured while sending your application. Our technical team has been informed of this issue.',
		applicationErrorDescription2:
			'Please try again and if the problem continues,',
		sureToLeave: 'Are you sure you want to leave?',
		processUncompleted:
			'Please note that if you leave now, any progress you’ve made will not be saved. To complete this process later, you’ll need to start over. ',
		cardPlatform: 'Platform',
		setDemoAccount:
			'We´re setting up your new demo account. Once it´s ready, you´ll find all the details right here.',
		cancel: 'Cancel',
		active: 'Active',
		accountSettings: 'Account settings',
		changePw: "Change this account's password",
		changeLv: "Change this account's leverage",
		setLv: "Set your account's new leverage",
		underReview: 'Your update is under review',
		underReviewDesc:
			'Your new account leverage is under review and will be verified shortly. Our team will reach out to you via email once the process is complete.',
		successLev: 'Your leverage has been successfully updated!',
		changePsw: 'Change your password',
		forgotPw: 'Forgot your password? Please, {contact}.',
		updatePw: 'Your password has been successfully updated!',
		statusTooltip:
			"Your account may be inactive for several reasons, such as missing requested information or documents. Check your cabinet for any alerts. If you're unsure of the reason, please {contact}.",
		failedReq: "We're sorry! An error ocurred",
		failedReqDesc:
			'Please try again. If the problem continues, {contact} for assistance. ',
		forex: 'Forex and CFDs',
	},

	//CreateDemoAccounts
	demoAccounts: {
		login: 'Login',
		pass: 'Password',
		currencyTwo: 'Currency',
		server: 'Server',
		ilc: 'iLC',
		xleverage: 'xLeverage',
		dontForget:
			"Don't forget to save your credentials  before clicking any button or closing this window. This info will also be sent to your registered email.",
		downloadCred: 'Download credentials',
		choosePlatform:
			"Great! Now you're ready to choose and download your trading platform",
		ifYouChooseMT4:
			"If you've chosen MetaTrader 4 for Mac OS, please note that the installation process is different. You can find guidance on installation",
		ifYouChooseMT4Continuation: '',
		thanksForRegistering: 'Thanks for registering!',
		otherStock:
			'A Tradeview representative will get in touch with you shortly to help you set up your new demo account.',
		stockMT52: 'While your account is being set up, feel free to ',
		stockMT53: 'explore our website ',
		stockMT54: 'and discover more about Tradeview.',
		accountTypeDemo:
			"The account type allows you to select the leverage you can get in your account <br><br> X-Leverage: 1:400 <br> ILC: 1:200 <br> Stock: 1:1 <br><br> Not sure which account type to choose? You can review them <a href='https://www.tvmarkets.com/trading/accounts/' target='_blank'>here</a>",
		applicationCompleted: 'Your demo account has been created!',
		pdfCredentialTitle: 'Dear trader',
		pdfCredentialDescription1:
			'Thanks for choosing us to kickstart your trading journey.',
		pdfCredentialDescription2: 'We´re excited to have you on board.',
		pdfCredentialDescription3: 'Here are your account credentials:',
		pdfCredentialEmail: 'Email:',
		pdfCredentialPassword: 'Password:',
		pdfCredentialCurrency: 'Currency:',
		pdfCredentialServer: 'Server:',
		pdfCredentialInstructions: 'Instructions:',
		pdfCredentialInstructions2: 'Use your registered email and password',
		pdfCredentialTo: 'to',
		pdfCredentiallogin: 'log in',
		pdfCredentialTVAccount: 'to your Tradeview account.',
		pdfCredentialChangeP: 'You can change your password or set a 2-Factor',
		pdfCredentialSettings:
			'Authentication in the ‘Settings’ section of the Cabinet.',
		pdfCredentialFamiliarize:
			'Familiarize yourself with our platform, explore the features,',
		pdfCredentialExperience: 'and start experiencing the Tradeview difference.',
		pdfCredentialSupport:
			"We're here to support you every step of the way. If you have any questions",
		pdfCredentialNeed:
			'or need assistance, feel free to reach out to our dedicated',
		pdfCredentialTeam: 'support team.',
		pdfCredentialHappy: 'Happy trading!',
		pdfCredentialRegards: 'Best regards,',
		pdfCredentialTVTeam: 'The Tradeview Team',
	},

	//Create Live Accounts
	liveAccount: {
		login: 'Login',
		pass: 'Password',
		server: 'Server',
		platform: 'Platform',
		status: 'Status',
		statusFalse: 'Enabled',
		statusTrue: 'Disabled',
		dontForget: `Don't forget to save your credentials  before clicking any button or closing this window. This info will also be sent to your registered email.`,
		downloadCred: 'Download credentials',
		applicationCompleted: 'Your live account has been created!',
	},

	//credit card
	credit: {
		edit: 'Edit',
	},

	//Banck Transfer add found Skrill
	addFounds: {
		amount: 'Amount',
	},

	//fidelity
	fidelity: {
		routingNum: 'Routing number',
		swiftCodebic: 'Swift code/BIC',
		disclaimer:
			'These deposit instructions are for use to residents of the Cayman Islands only. Please use an alternative bank if you are not sending from the Cayman Island.',
	},

	//Bbva
	bbva: {
		ruc: 'RUC',
		accountninfo: '0011-0351-0100035781',
		nameBenef: 'Name of beneficiary',
		interbank: 'Interbank number (CCI)',
	},

	//deposit
	deposit: {
		title: 'Select a deposit method',
		depositMethod: 'Deposit method',
		processingCards: 'PROCESSING TIME',
		fee: 'FEE',
		crypto: 'Crypto',
		digitalWallets: 'Digital wallets',
		cardTransfer: 'Card',
		wireTransfer: 'Wire transfer',
		btnDepositFunds: 'Deposit Funds',
		selectAnOption: 'Select a funding method',
		depositUnderReview: 'Deposit under review',
		depositUnderReviewDescription:
			'Your deposit is now under review. Our team will reach out to you via email once the deposit process its done.',
		depositUnderReviewErrorDescription:
			'We encountered an issue while processing your deposit. Please verify your payment information and try again. If the problem continues, contact us.',
		depositCompleted: 'Your deposit has been completed!',
		depositCompletedDescription:
			'Your funds will be available in your destination account shortly. The processing time depends on the deposit method you have selected.',
		despositInCompletedDescription:
			'We encountered an issue while processing your deposit. Please verify your payment information and try again. If the problem continues,',
		contactUs: 'contact us',
		depositNotCompleted: 'Your deposit has not been completed',
		depositNotCompletedDescription:
			'Please review your deposit information and try again. If the issue continues happening, contact us.',
		depositWithClick: 'Or deposit seamlessly with just a click or a glance. ',
		keepInMind: 'Keep in mind:',
		keepInMindTC: 'You can make up to 5 transactions within a 24-hour period.',
		ltd: {
			depositDisclaimer:
				'Losses can exceed the initial invested amount. Third-party deposits will NOT be accepted. All deposits must be made by the account owner. The trading platform denomination is the American Dollar.Tradeview Ltd. reserves the right to return/refund deposits made via credit cards instead of processing a withdrawal.',
		},
		latam: {
			depositDisclaimer:
				'Losses can exceed the initial invested amount. Third-party deposits will NOT be accepted. All deposits must be made by the account owner. The trading platform denomination is the American Dollar.Tradeview Financial Markets S.A.C. reserves the right to return/refund deposits made via credit cards instead of processing a withdrawal.',
		},
		accountNumberTitle: 'Trading account number',
		accountNumberDescription: 'Select the account you want to fund',
		currencyTitle: 'Currency',
		currencyDescription: 'Select a currency',
		amountTitle: 'Amount',
		amountDescription: 'Enter a cash amount',
		phoneNumberTitle: 'Phone number',
		confirmTitle: 'Review your transaction details',
		confirmDescription:
			'Take a moment to ensure the transaction details below are correct:',
		upholdCommission:
			'Users are responsible for covering transaction fees. Fee values depend on the transfer amount',
		upholdBanningTitle: 'Non-available geographies',
		upholdBanningDescription:
			"Uphold doesn't offer its services to residents of the following countries:",
		depositAmount: 'Enter the amount of your deposit',
		btcAlertTitle: 'BTC Deposit commission',
		btcAlertMessage:
			'A BTC Fiat conversion fee will apply to all trades. The fee is 1% for trades up to $250K and 1.5% for trades over $250K.',
		upholdWarningTitle: 'Direct BTC deposit to Tradeview commission',
		upholdWarningMessage:
			'BTC Fiat conversion fee of 1% for all trades up to $250K, and 1.5% for all trades above $250K.',
		bitPayCommission:
			'Crypto transaction fees are assumed by users (Values depend on transfer amount).',
		bitPayWarningTitle: 'The Crypto processor charges following fees:',
		bitPayWarningMessage:
			'Exchange Fee: (1.05%), Network Fee (0.0003 BTC), Withdrawal Fee (0.0003 BTC).',
		bitpayFooterInfo:
			'Keep in mind: Tradeview is not responsible for any gain or losses on currency rates during any transaction.',
		interacFooterInfo:
			'Tradeview Financial Markets S.A.C. reserves the right to return/refund deposits made via credit cards instead of processing a withdrawal',
		tetherWarningTitle: 'Commission',
		tetherWarningMessage:
			'When making a deposit using cryptocurrencies there is a conversion fee of 0.7%.',
		copied: 'Copied!',
		tetherHashTitle: 'Hash',
		tetherHashDescription: 'Enter your hash',
		tetherTooltip:
			'A hash is a code composed of numbers and letters that are randomly generated through cryptography.',
		netellerFooterInfo:
			'Losses can exceed the initial invested amount. Third-party deposits will NOT be accepted. All deposits must be made by the account owner. The trading platform denomination is the American Dollar.Tradeview Ltd. reserves the right to return/refund deposits made via credit cards instead of processing a withdrawal.',
		fasapayAccountTitle: 'FasaPay account',
		fasapayAccountDescription: 'Enter your FasaPay account id',
		jpayFooterInfo: 'Currency exchange rate: 1 USD = 7 CNY(RMB)',
		addressTitle: 'Address',
		zipCodeTitle: 'Zip code',
		zipCodeDescription: 'Enter your zip code',
		countryTitle: 'Country',
		countryDescription: 'Select your country',
		cityTitle: 'City',
		cityPlaceholder: 'Select your city',
		skrillFooterInfo:
			'Losses can exceed the initial invested amount. Third-party deposits will NOT be accepted. All deposits must be made by the account owner. The trading platform denomination is the American Dollar.Tradeview Ltd. reserves the right to return/refund deposits made via credit cards instead of processing a withdrawal.',
		bitwalletFooterInfo:
			'Losses can exceed the initial invested amount. Third-party deposits will NOT be accepted. All deposits must be made by the account owner. The trading platform denomination is the American Dollar.Tradeview Ltd. reserves the right to return/refund deposits made via credit cards instead of processing a withdrawal.',
		clickBank:
			"Click on your preferred bank's name to access essential account information, making it easy to complete your deposit through your bank platform. After the transfer is completed, send the transaction receipt to your broker for validation. Once validated, your funds will be promptly added to your trading account, ensuring a seamless and efficient process.",
		banks: 'Banks',
		processingTime: 'Processing time:',
		commision: 'Comission:',
		bankProcessingTime: 'Processing time: 1 to 2 business days aprox.',
		bankCommision: 'Commission: No',
		sameDay: 'In the same day',
		depositInstructions:
			'These deposit instructions are for use to residents of the Cayman Islands only. Please use an alternative bank if you are not sending from the Cayman Island.',
		downloadInfo: 'Download info',
		intermediaryBank: 'Intermediary bank name',
		intermediarySwift: 'Intermediary swift',
		beneficiarySwift: 'Beneficiary swift:',
		beneficiaryBank: 'Beneficiary bank',
		paymentProvider: 'Payment provider address',
		accountHolder: 'Account holder name',
		virtualIban: 'Virtual IBAN',
		bic: 'BIC',
		createLiAcc: 'Create a live account',
		waitTitle: 'Loading New Tab',
		waitDescription:
			'Please do not close this window. A new tab will automatically open to continue the process. You may continue browsing or wait here in the meantime.',
		depositTypeTitle: 'Select a deposit type',
		depositTypeDescription:
			'Choose your preferred deposit type and the corresponding payment method',
		typeCash: 'Cash payment',
		typeBankTransfer: 'Bank wire transfer',
		countryBankTitle: 'Payment method',
		countryBankDescription: 'Select a payment method',
		minimumAmount: 'The minimum amount for',
		maximumAmount: 'The maximum amount for',
		pleaseNote: 'Please note:',
		validateDeposit:
			'To validate your deposit, send your broker the transaction receipt once the transfer is complete. After validation, your funds will be promptly added to your trading account, ensuring a seamless and efficient process.',
		withdrawalchooseMatch:
			'The withdrawal method you choose in the future must match the deposit method.',
		notResponsibleDuringTransactions:
			'Tradeview is not responsible for any gains or losses resulting from currency rate changes during transactions.',
		minDeposit: 'The minimum deposit amount for this method is $100.00',
		cryptos: {
			comission: {
				title: 'Commission',
				text: 'Tradeview does not charge a deposit  fee. There is an exchange fee of 0,7% charged by our processor.',
			},
			scanText1: 'Scan this QR code using the scan feature in your exchange',
			scanText2: 'app, or manually copy the crypto address below:',
			copyText:
				'Copy the cryptocurrency address below and paste it into your exchange app: ',
		},
		processTimeSameDay: 'In the same day',
		processTimethreeDay: 'Up to 3 days',
		commisionYes: 'Yes',
		commisionNo: 'No',
		onReviewTitle: 'Deposit under review',
		onReviewText:
			'Your deposit is now under review. Our team will reach out to you via email once the deposit process its done.',
		bitPayFees: 'The crypto processor charges the following fees:',
		bitPayExchange:
			'Exchange Fee: 1.05% <br> Network Fee: 0.0003 BTC <br> Withdrawal Fee: 0.0003 BTC',
		minimumAndMaxiumAmountInterac: 'Min. $75 CAD - Max. $9,999 CAD',
		minumumAndMaxiumAdversInterac:
			'Interac has a $75.00 min. deposit in place. Any funds under $75.00 will be rejected.',
		routingNumber: 'Routing number (ABA)',
		beneficiaryBankAddress: 'Beneficiary bank address',
		beneficiaryAccountNumber: 'Beneficiary account number',
		beneficiaryAccountName: 'Beneficiary account name',
		paymentDetailsFFC: 'Payment details FFC',
		iban: 'IBAN',
		swiftBic: 'SWIFT/BIC',
		currencies: 'Currencies',
		sortCode: 'Sort code',
		entersortCode: 'Please enter your sort code',
		beneficiary: 'Beneficiary',
		beneficiaryIBAN: 'Beneficiary IBAN/Acct',
		cci: 'CCI',
		moreInformationTitle: 'Additional information required',
		moreInformationText:
			'When the total of your deposits reaches 25,000 USD or more, a one-time additional verification is required. To complete your deposit, please click ‘Continue’ and provide the requested employment and financial details.',
		moreInformationTextLTD:
			"One-time additional verification is required. To complete your deposit, please click 'Continue' and provide the requested employment and financial details.",
		selectMethod: 'Card payment provider',
		cryptoMena:
			'This information is only required once for cryptocurrency payments. ',
		noOptions: 'No options available',
		digitalWalletsDisclaimer:
			'• Losses can exceed the initial invested amount. <br> • Third-party deposits will NOT be accepted. All deposits must be made by the account owner. <br> • The trading platform denomination is the American Dollar. ',
		continueWithMyExchangeApp: 'Continue with my exchange app',
		continueWithPayX: 'Continue with PAY X',
		continueAutoDeposit: 'Continue with Auto-Deposit',
		orDepositDirectly: 'Or deposit directly:',
		maximumAmountPSE_COL:
			'For the PSE payment method, the maximum amount is 600 USD.',
		swiffyFooterInfo:
			'Tradeview Ltd. reserves the right to return/refund deposits made via credit cards instead of processing a withdrawal.',
	},

	//Email
	email: {
		company: 'Company news',
		selectOne: "Trading news ( Surf's Up! )",
		selectTwo: "Surf's Up!",
		update: 'Update',
		manageSubscription:
			'Manage your subscriptions here. Select the topics you would like to receive branded newsletters from',
		dontReceiveEmails:
			'If you no longer want to receive emails on any of the above topics, just uncheck them. Don\'t forget to click the "Update" button.',
	},

	//password
	password: {
		title: 'Change Password',
		subTitle:
			'To change your password please request a one-time code to your email account.',
		request: 'Request Code',
		submit: 'Submit',
		code: 'Code',
		current: 'Current password',
		confirm: 'Confirm new password',
		setPasswordPreference: 'Set your account preferences',
		mailingSubscriptions: {
			title: 'Your mailing subscriptions',
			description:
				'Manage your subscriptions here. Receive key insights and analysis straight to your inbox or company information to stay up to date.',
			subscriptionUpdated: 'Your subscriptions have been updated',
			subscriptionError: 'Ups! Something Whent wrong, Please contact support',
		},
		passwordSettings: {
			title: 'Your password settings',
			description:
				'Manage your password settings to ensure your accounts security. Here you can change it whenever you want to.',
		},
		factor2Verification: {
			title: 'Set your 2-factor authentication',
			description:
				'Strengthen your account security by adding this protocol. Prevent unauthorized access to your account by requiring a security code each time you log in.',
			firstStepTitle: 'Step 1: Download an authentication app',
			firstStepFirstParagraph:
				'Download an authentication app on your mobile device. We recommend searching Google Authenticator on the Play Store or App Store.',
			firstStepSecondParagraph:
				'When you enable 2-step authentication (2FA), you will need to enter your password as well as a code that will appear on your authentication app.',
			turnOn: 'Turn on',
			secondStepTitle: 'Step 2: Enter authentication code',
			scanQRCode:
				'Scan the following QR code using the authentication app and enter the six-digit code shown in the authentication app',
			enterCodeManually:
				'Enter the six-digit code shown in the authentication app',
			invalidCode: 'Entered code is invalid. Please try again.',
			authCompleted:
				'Your authentication code on our platform has been successfully completed.',
			disable: 'Disable',
			succesfullyActivatedAuth:
				"Good job. You have successfully completed the authentication process, adding an extra layer of security to your account. If you ever decide to change these settings, simply locate and click the 'Disable' button.",
			deactivatedNotification:
				'Your two-factor authentication has been deactivated.',
			insertCode: 'Insert the 2FA code',
			downloadAuth: 'Download Google Authenticator',
			enterAuthCode: 'Enter your authentication code',
			codeSuccess: 'Code on our platform has been a success',
		},
		accountPreferences: 'Your account preferences',
		changeYoutPassword: 'Change your password',
		requestChangePassword:
			"If you want to change your password you'll need to request a one-time code to your registered email.",
		requestCode: 'Request code',
		didntGetIt: 'Didn’t get it? ',
		tryAgain: 'Try again',
		enter6DigitCode: 'Enter 6 digit code. E.g. 123456',
		enterValidOTP: 'Entered code is invalid. Please try again.',
		notYourCurrentPassword: ' This is not your current password',
		passwordConditions:
			'Password must be at least 8 characters and include at least one lowercase, one uppercase, one number, and one special character.',
		passwordsDontMatch:
			"Entered passwords don't match. Please double-check and try again",
		newPassword: 'New password',
		confirmPassword: 'Confirm password',
		passwordSuccessfulyChanged: 'Your password has been successfully updated!',
		sampleEmail: 'A one-time code was sent to ',
		cantResendCode: "We can't resend your code right now. Please try again.",
		enterCurrentPassword: 'Enter your current password',
		enterNewPassword: 'Enter your new password',
		enterConfirmNewPassword: 'Confirm your new password',
		passwordUpdated: 'Your password has been successfully updated!',
		successful2Factor:
			'Your two-factor authentication has been completed successfully!',
		areYouSure: 'Are you sure you want to disable the 2FA?',
		changePasswordDescription:
			'Change your account settings, manage your subscriptions, and ensure your account security.',
	},

	//Contact
	contact: {
		requestCall: 'Request a call',
		phoneNumber: 'Phone number',
		preferedTime: 'Preferred time',
		selectPreferedTime: 'Select your preferred time to be called',
		enterPhone: 'Enter your phone number ',
		knowMore: 'Know more about us',
		callSchedule: 'Your call has been scheduled',
		callScheduleDescription:
			"We'll contact you as soon as one of our agents is assigned to your call. Please note, this call will occur within 24 hours of your request, starting from the following workday.",
		failedToSchedule: "We couldn't schedule your call",
		contactUsErrorCall:
			'We apologize for the inconvenience. Please try again, if the problem continues, feel free to use any other available option to connect with us.',
		weWillContactYou:
			'One of our service agents will be contacting you within the time frame you selected.',
		unableToContactYou:
			'Unfortunately, we were unable to schedule the call at this time. Please double-check your information and try again.',
		infoInvalid:
			'The provided information is not valid. Please review and try again.',
		inNeedOfHelp: "In need of assistance? We're here to help!",
		inNeedOfHelpDescription:
			"Whether  you want additional updates on your requests or need to confirm details about your accounts, we've got your back!  Reach out to us and we’ll assist you.",
		chatDescription:
			"Feel more comfortable by chat? We're just a message away!",
		chatDescription1: 'Our agents are available 24/7 on US workdays.',
		mailForward:
			"Not as urgent? Send us an email with your questions or concerns, and we'll get back to you as soon as possible.",
		emailUs: 'Email us',
		letsChat: 'Let’s chat',
		scheduleACall: 'Schedule a call',
		contactDisclaimer:
			'If you prefer, you may reach out to us directly by phone at',
		orVia: 'or via email at',
		contactDisclaimerLatam:
			'If you prefer, you can contact us directly by e-mail at',
		stayConnected: 'Stay connected with us',
		timeZone: 'Time zone',
		selectTimeZone: 'Select a timezone',
		customDate: 'I want to select a date and time',
		soonAsPossible: 'As soon as possible',
		callWhen: 'When should we call you?',
		contactHelper:
			"Please note:  Our scheduled phone calls are conducted exclusively in English. If you choose the 'As soon as possible' option, we'll contact you within 24 hours on the next workday.",
		selectDate: 'Select a date',
		selectTime: 'Select a time',
		selectOption: 'Select an option',
		preferredDate: 'Preferred date',
		sendEmail: 'Send us an email',
		subject: 'Subject',
		describeEmail: 'Describe the purpose of your email',
		concerns: 'Write your questions, concerns, or comments here.',
		yourMessage: 'Your message',
		emailSuccessful:
			"Your email has been successfully delivered! We'll get back to you as soon as possible.",
		emailSuccessfulTitle: 'Email received',
		emailErrorfulTitle: 'Email delivery issue',
		emailErrorMessage:
			'We apologize for the inconvenience. Please try again. If the problem continues, feel free to use any other available option to connect with us.',
		japanNotice:
			'For Japan Standard time zone, calls are available only between 10:00 PM and 12:00 AM or at 6:00 AM. We apologize in advance for the inconvenience.',
		messageError: 'Message cannot exceed 900 characters',
		messageErrorShort: 'Message must be at least 15 characters long',
		titleError: 'Subject cannot exceed 60 characters',
		titleErrorShort: 'Subject must be at least 4 characters long',
		preferredDate: 'Preferred date',
		failedAttempt: 'Please try again later',
		callDate: 'Your call is scheduled',
		contactSetDate:
			'One of our agents will contact you in the date and time you selected:',
		errorPhoneNumber: 'Phone number cannot contain letters or symbols',
		callDescription:
			'Care to speak with one of our agents? We respect your time. Book a convenient time for you! ',
	},

	//menu
	menu: {
		appli: 'Applications',
		account: 'Accounts',
		platforms: 'Downloads',
		history: 'History',
		deposit: 'Deposit',
		transfer: 'Transfer',
		withdraw: 'Withdraw',
		tradingTools: 'Trading tools',
		settings: 'Settings',
		passwordsettings: 'Password settings',
		emailsettings: 'Email settings',
		authenticationsettings: 'Authentication settings',
		contactUs: 'Contact us',
		accessDemo: 'Access demo account',
		accessRestricted: 'Access restricted',
		btnReSubmit: 'Re-submit document',
		temporarilyUnavailable: 'These features are temporarily unavailable',
		sorryFeature:
			'We’re sorry, but the features you’re trying to access are not available yet. Once you’ve completed your application process and your account is set up, you’ll be able to access them.',
		btnContinue: 'Continue',
		liveFeature: 'These are live account features',
		featureOnly:
			'The features you’re trying to access are available only for live accounts. Create a live account now to get access.',
		call: 'No time to lose? Our support team is a phone call away 24/5 GMT.',
		chat: 'Prefer to chat? Let’s do that. Our agents are available 24/7 on US workdays.',
		mail: 'Not as urgent? Send us an email, our experts will get back to you.',
		call2: 'Call us',
		chat2: 'Chat with us',
	},

	//sidebar applications process
	sidebar: {
		help: 'Need help?',
		call: 'Call us',
		chat: 'Chat with us',
		mail: 'Mail us',
		notReady: 'Not ready for a live account?',
		btnDemo: 'Create a demo account',
	},

	//form signature
	formSignature: {
		authorised: 'Authorised client signature, sign above',
		or: 'OR',
		accept: 'Confirm signature',
		error1: "You haven't confirm the signature, please do it.",
		drop: 'Drop your files here or',
		browse: 'browse',
		make: "Make sure the file is JPEG, PNG, or PDF format and its size doesn't exceed 2 MB.",
		error_help: "You haven't upload a file with your signature, please do it.",
	},

	//Text of application process form
	applicationForm: {
		duplicateShareholder:
			'A shareholder with this name and last name already exists.',
		duplicateEmail: 'A shareholder with this email already exists.',
		details: 'Details',
		idVerification: 'ID verification',
		proofResidence: 'Proof of residence',
		proofResidenceConsent: 'Proof of residence and consent',
		consent: 'Consent',
		liveIndividual: 'Live Individual Account',
		liveJointAccount: 'Live Joint Account',
		primaryAccountHolder: 'Primary account holder',
		title: 'Personal details',
		subtitlePlatform:
			'After creating your first Tradeview account, you can easily open more accounts for different financial assets without the need to fill out the entire form again.',
		subtitleDocument:
			"Which type of documentation you'd like to use for verification?",
		subtitleResidence:
			"Which proof of residence type you'd like to use for verification?",
		subtitleExperience:
			'Select the option that best represent your experience trading Forex, Stocks, Futures, Derivatives or CFDs.',
		submitContact: 'contact us',
		drop: 'Drop your files here or',
		browse: 'browse',
		make: "Make sure the file is JPEG, PNG, or PDF format and it's size doesn't exceed 2 MB.",
		makeMaxSize:
			"Make sure the file is JPEG, PNG, or PDF format and it's size doesn't exceed 15 MB.",
		tryAgain: 'Try Again',
		openFile: 'Open File',
		submitted: 'Application submitted: Review in progress',
		thankyou:
			'Thank you for submitting your account application. Your request is now under review and will be verified shortly.',
		operations:
			'Our operations team will reach out to you if any further documentation is required.',
		appreciate:
			'We appreciate your cooperation and will keep you updated on the progress.',
		gotocabinet: 'Go to my cabinet',
		explore: 'Explore Tradeview',
		acknowledgementText:
			'By signing below, I acknowledge and agree to the documents listed in the previous step of this process.',
		acknowledgementTextLATAM:
			'Carefully review and understand each item on this page before checking the agreement boxes and signing.',
		acknowledgementTextLTD:
			'Please review and ensure you understand each item below before submitting your application. To continue, please check the acknowledgment boxes, provide your signature and click on ‘Submit’.',
		jointConsent:
			'Carefully review and understand each item on this page before checking the agreement boxes and signing.',
		secondaryAccount: 'Secondary holder addition',
		secondaryAccountDesc:
			"To finish the account setup, it's mandatory to create the second account holder. ",
		primaryAccountHolder: 'Primary account holder (you):',
		secondaryAccountHolder: 'Secondary account holder:',
		corporateResol: 'Corporate resolution',
		corporateResolDisclaimer:
			'To upload the file, drop your files into the field or browse using the icon.',
		corporateResolDisclaimer2:
			"Make sure the file is JPEG, PNG, or PDF format and it's size doesn't exceed 2 MB.",
		corporateResolDesc:
			"You can download and fill out Tradeview's standard corporate resolution by clicking {link}, or you may provide your own.",
		shareHolder: 'Shareholder information',
		shareHolderDesc:
			'Add up to 9 shareholders, each with a minimum 10% share, or skip this step for a corporate account without shareholders.',
		addShareholder: 'Add a new shareholder',
		or: 'or',
		completeShareholder: 'Complete shareholder details',
		shareholder: 'Shareholder',
		information: 'Information',
		aboutToComplete:
			'You are about to complete the information for your shareholder #{number}',
		noShareAvailable:
			'The combined percentage of the shareholders and account holder cannot exceed 100%. Please try again.',
		percentageLow:
			'The combined percentage of the shareholders and account holder needs to be 100%. Please verify.',
		aboutToCompleteDesc:
			'Before starting, prepare the following documents of the shareholder #{number}:',
		accountHolderDisclaimer:
			'For shareholders owning more than {percentage} of the company, we require personal information, ID, and proof of address. From shareholders with less than {percentage} ownership, we only request their name and last name.',
		deleteShareholder:
			"To edit shares or upload a shareholder's ID and proof of address, delete the existing entry and add it again.",
		sendInvitation: 'Send invitations',
		pendingShareholderTitle: 'Pending shareholders Information',
		pendingShareholderDesc:
			'You have pending shareholders to complete. Please fill out the information for each shareholder to continue.',
		inviteSentSuccess: 'The invitation was successfully sent',
		inviteSentSuccessDesc:
			'Track down the application progress of each shareholder on the Shareholder information section.',
		primaryHolder: 'Account holder (you)',
		sharePercent:
			'Shares represent ownership in the company. Allocate percentages to shareholders to define their ownership stake in the corporate structure.',
		accountHolder: 'Account holder (you)',
		shareHolderDetails: 'Shareholder {user} details:',
		continueNoShareholder: 'Continue without shareholders',
		infoSwitchOff:
			'If required by your jurisdiction, our backoffice team will request it from you in the future.',
		fileNotValid: 'Please upload a file in a valid format and size.',
		resolUpload:
			"Make sure the information and images in the file are clear and understandable. <br/><br/>Feel free to upload the documents you have at the moment. Don't worry if some are missing; you can upload or send them later upon request. ",
		upDocument: 'Document upload',
	},

	expiredDocument: {
		resubmit: 'Re-submit your documents',
		settingsDesc:
			'Update your ID and/or proof of address documents by re-submitting them here to keep operating seamlessly.',
		resubmitDesc:
			'Your verification document(s) have expired. Please upload a new file now or within the next {days} days in your cabinet settings. If you fail to do so, you won’t be able to transfer, withdraw, or deposit until updated.',
		IDVerse: 'Which ID verification method would you like to use?',
		IDVerseDesc:
			'Updating your identity with a government-issued ID ensures the security and legitimacy of your account.',
		idTooltip:
			"Choose how you'd like to complete your ID verification. You can scan the QR code with your phone or open a new tab on your computer. Select your preferred method below.",
		cancelModal: 'Are you sure you want to leave?',
		cancelModalDesc:
			"Please remember, you must complete this step within the next {days} days. If you fail to do so, you won't have access to the withdrawal, deposit, and transfer functionalities in your cabinet until the required document(s) are updated.",
		accessRestricted: 'Access restricted',
		uploadDocs: 'Upload your document(s)',
		resubmitDocs: 'Re-submit document',
		accountholderId: 'Account holder ID verification',
		accountholderPoa: 'Account holder proof of address',
		companyPoa: 'Company proof of address',
		companyPoaDesc:
			"Confirm your company's location to ensure compliance with regulatory standards.",
		restrictedID:
			'We noticed during a random check that the ID you provided is now expired. To ensure the security of your account, we have temporarily blocked your transfer, withdrawal, and deposit functionalities.',
		restrictedID2:
			'Please upload a new ID now to restore access and continue enjoying a seamless experience in your cabinet.',
		restrictedPOA:
			'We noticed during a random check that the proof of address you submitted is now expired.  To ensure the security of your account, we have temporarily blocked your transfer, withdrawal, and deposit functionalities.',
		restrictedPOA2:
			'Please upload a new proof of address now to restore access and continue enjoying a seamless experience in your cabinet.',
		restrictedBoth:
			'We noticed during a random check that your submitted ID and proof of address are now expired.  To ensure the security of your account, we have temporarily blocked your transfer, withdrawal, and deposit functionalities',
		restrictedBoth2:
			'Please upload new files now to restore access and continue enjoying a seamless experience in your cabinet.',
		restrictedLimited:
			'Your verification document(s) are missing. Please upload them to gain access; until then, your trading account will remain restricted.',
		confirmationLimited:
			'Please remember to complete this step. If you don’t, your trading account will remain disabled until your document(s) are uploaded.',
		alertExpiredDocsSuccess:
			'You successfully submitted your document. It is now under review. If any further documentation is required, our team will reach out to you.',
		alertExpiredDocsError:
			'Please upload new document(s) now or within the next {days} days.',
		alertMissingDocsError:
			'Please upload your document(s) to enable your trading account.',
		submitDoc: 'Submit document(s)',
		idverseD:
			'Submitting a government-issued ID ensures the security and legitimacy of your account.',
		idverseT:
			"Choose how you'd like to complete your ID verification. You can scan the QR code with your phone’s camera, send a link to your phone via SMS or continue on your current device.",
	},

	//Aplication Process IDVerse
	appliProcessIDverse: {
		QRdescription: "Use your phone's camera to scan the QR code.",
		IDVerseTitle: 'Which ID verification method would you like to use?',
		IDVerseTitleLatam: 'Choose your preferred ID verification method',
		IDVerseTitleManualDoc: 'Choose your preferred ID verification method',
		IDVerseTitleManualDocTitle: 'Choose a type of document',
		IDVerseTitleManualDocDesc:
			"Please select the type of document you'd like to use for verification:",
		IDVerseTitleManualDocMainDesc:
			'The ID verification process is essential for preventing fraud and ensuring the responsible and lawful use of our services. We sincerely appreciate your cooperation.',
		IDVerseDesc:
			'For a smoother experience, we suggest completing this step on your phone using one of the following options:',
		or: 'OR',
		verifyOnNewTab: 'Continue on your current device',
		sendLinkSms: 'Send link via SMS',
		verifyPopupConfig:
			'Please ensure that your browser`s pop-up blocker is disabled. For more information.',
		clickHere: 'click here',
		alertDetail:
			'Please note that you can only access the verification process once per unique link. If you need to access it again, <strong>please refresh your page and then press on your preferred verification method.</strong>',
		alertDetailMobile:
			'Please note that you can only access the verification process once per unique link. To complete the verification process <strong>please refresh your page and then press `Verify my ID`. If you already completed it, press Continue.<strong>',
		//Modal Verify Identity
		modalVerifyTitle: 'Verify your identity',
		btnVerifyID: 'Verify my ID',
		modalVerifyDesc1:
			'To proceed, you must choose an ID verification method and complete the process.',
		modalVerifyDesc2:
			'If you have already completed it and are still unable to proceed, please contact us  as soon as possible.',
		modalVerifyButton: 'Choose an ID verification method',
		//Skip step
		modalSkipTitle: 'Are you sure you want to skip this step?',
		modalSkipDesc1:
			'You can temporarily skip this step and complete it later in your client cabinet, or choose a document type now to finish the process.',
		modalSkipDesc2:
			'Please note that completing this step is required to activate your trading account.',
		btnVerifyAddress: 'Verify my address',
		btnVerifyIdentity: 'Verify my identity',
		btnSkip: 'Skip for now',

		modalSendSMSChangeNumberTitle: 'Enter a new mobile number',
		modalSendSMSChangeNumberDesc:
			'Enter the mobile number where you want to receive the ID verification link via SMS.',
		modalSendSMSChangeNumberButton: 'Send',
		modalSendSMSChangeNumberCancel: 'Cancel',
		modalSendSMSChangeNumberCheck: 'Save as my registered mobile number.',
		modalSendLinkSMSFailedTitle: 'An error ocurred',
		modalSendLinkSMSFailedDesc:
			'We were unable to send the link via SMS. Please check the number and try again.',
		modalSendLinkSMSFailedButtonCancel: 'Cancel',
		modalSendLinkSMSFailedButtonChangeNumber: 'Change number',

		modalSendLinkSMSTitle: 'Link sent via SMS',
		modalSendLinkSMSDesc:
			'A link has been sent to your registered mobile number via SMS. Please open the link on your phone and follow the steps to complete your ID verification.',
		modalSendLinkSMSButtonReSend: 'Re-send',
		modalSendLinkSMSButtonOkay: 'Okay',
		clickHere: 'Click here',
		or: 'Or',
		modalSendLinkSMSOptionalNumber: 'Send to a different mobile number',
		uploadCurrentDevice: 'to upload your document from your current device.',
		retryIn: 'please try again in',
		chooseTooltip:
			"Choose how you'd like to complete your ID verification. You can scan the QR code with your phone’s camera, send a link to your phone via SMS or continue on your current device.",
		sendToDifferentNumber: 'Send to a different mobile number',

		chromeInstructions: {
			step1: 'Go to Settings',
			step2:
				'Navigate to Privacy and Security > Site settings > Pop-ups and redirects',
			step3: "Toggle off the 'Block' option",
		},
		safariInstructions: {
			step1: 'Go to Safari > Preferences',
			step2: 'Select Websites > Pop-up Windows',
			step3: 'Adjust settings as needed',
		},
		firefoxInstructions: {
			step1: 'Click the menu icon.',
			step2: 'Go to Preferences > Privacy & Security > Permissions.',
			step3: 'Adjust pop-up settings as necessary.',
		},
		assistanceText: `If you encounter any difficulties, please`,
		assistanceText2: `contact us for assistance.`,
	},

	//Application process CORPORATE form
	applicationFormCorporate: {
		liveCorporateAccount: 'Live Corporate Account',

		//Company details
		companyDetailsTitle: 'Company details',
		nameLabel: 'Company name',
		namePlaceholder: 'Enter your company name',
		businessTypeLabel: 'Business type',
		businessTypePlaceholder: 'Select a type of business',
		companyEmailLabel: 'Company email',
		companyEmailPlaceholder: 'Enter a coporate email',
		companyEmailTooltip:
			'We ask for a company email to ensure secure communication and verify the legitimacy of corporate accounts. It helps us maintain a safe and reliable trading environment for your business.',
		businessDescriptionLabel: 'Business description',
		businessDescriptionPlaceholder:
			'Enter a brief description of the company`s size and the services it offers.',
		businessDescriptionTooltip:
			'This helps us understand your company`s activities and purpose. Providing a clear description ensures a smooth account approval process and helps us tailor our services to meet your business needs.',

		//Company address
		companyAddressTitle: 'Company address',
		companyAddressTitleTooltip: `This refers to the country where your business is primarily located. Accurate information helps us customize our services based on regional requirements and regulations.  
		If your country of location is not listed in the options, we regret to inform you that we are unable to offer our services in your location.`,

		//Account ownership
		accountOwnershipTitle: 'Account ownership information',
		dateIncorporationLabel: 'Date of incorporation',
		dateIncorporationTooltip:
			'This is the date when your company was officially registered. Providing this date helps us verify your business`s legal status and ensures compliance with regulatory requirements.',
		countryOfRegistrationLabel: 'Country of registration',
		countryOfRegistrationPlaceholder: 'Select a country',
		countryOfRegistrationTooltip:
			'This is the country where your company is officially registered. Providing this information helps us understand the legal jurisdiction of your business, ensuring compliance with regional regulations.',
		marketCapitalizationLabel: 'Total market capitalization or net worth',
		marketCapitalizationPlaceholder:
			'Enter your company total market capitalization',
		marketCapitalizationTooltip:
			'Total market capitalization encompasses the overall market value of a company`s outstanding shares, while net worth represents the total value of a company`s assets minus its liabilities.',
		isSubsidiaryLabel: 'Parent company',
		isSubsidiaryPlaceholder: 'Enter the parent company name',
		isIndividualRegularMemberLabel:
			'Is the individual completing this form a regular member/partner, or do they represent the ultimate beneficiary owners of the entity mentioned in this relationship?',

		//Tax residency information
		taxResidencyTitle: 'Tax residency declaration',
		isUSCompanyLabel:
			'Is the company classified as a US entity or a US tax resident?',
		taxResidencyContryLabel:
			'The company hereby confirms that, for tax purposes, it is a resident in the following country:',
		taxResidencyContryListLabel: 'Country',
		taxResidencyContryListPlaceholder: 'Select a country',
		taxResidencyReferenceCodeLabel: 'Tax reference code',
		taxResidencyReferenceCodePlaceholder: 'Enter your tax reference code',
		modalRegulationP:
			"We're sorry. Due to regulation. we cannot provide services to companies based or considered tax residents in the US territory.",

		//Account type and platform information
		accountTypeTitle: 'Account type',

		// Financial details
		financialDetailsTitle: 'Financial details',
		financialDetailsTooltip:
			'You are required to disclose your company`s financial details to address risks properly for both parties (the company and Tradeview).',
		companyAnnualIncomeLabel: 'What is the company`s annual income',
		companyAnnualIncomeTooltip:
			'A company`s annual income or total turnover refers to the total revenue generated by an organization during a specific period of time, typically one year.',
		companyTotalAssetsLabel: 'What is the company total assets balance?',
		companyTotalAssetsTooltip:
			'The company`s assets balance is the value of the company`s savings, investments, real estate properties after deducting commitments.',
		companyLiquidAssetsLabel: 'What is the company liquid assets balance?',
		companyLiquidAssetsTooltip:
			'Your liquid assets balance is the sum of your cash, money, market instruments, and marketable securities.',
		companyOriginAssetsLabel:
			'What is the origin of the company`s total assets?',
		companySourceFundsLabel:
			'What is the source of the company`s deposits/funds?',
		companyPruoseAccountLabel: 'What is the purpose of the account?',
		companyIsConnectedBanktruptcies:
			'Is the company connected to banktruptcies?',
		companyIsConnectedBanktruptciesDetailsLabel: 'Bankruptcies details',
		companyIsConnectedBanktruptciesDetailsPlaceholder:
			'Include information about bankruptcies associated with the company.',
		companyIsConnectedBanktruptciesDetailsTooltip:
			'The company is required to disclose any bankruptcy affiliations to address risks for both parties (the company and Tradeview). However, please be assured that if the company has any connections to bankruptcy, it is still welcome to proceed with the application process.',

		//Proof of address
		proofAddressTitle: 'Proof of address',
		proofAddressTitleCorporate: 'Company proof of address',
		proofAddressDescription:
			'Confirm your company location to ensure compliance with regulatory standards.',

		//Company Account Consent
		companyAccountConsentTitle:
			'Thanks for sharing your corporate details with us.  Let`s move on!',
		companyAccountConsentDescription1:
			'Now, let`s fill in the account holder`s information. You can edit the provided details at any point using the progress list on the right side of the screen. Simply click on the pencil icon next to the information you`d like to edit.',
		companyAccountConsentDescription2:
			'Please note that, apart from the Government-issued photo ID and proof of residence documents, you can upload the necessary documents at your convenience—either now or later when requested.',
		companyAccountConsentDocumentsTitle:
			'Before getting started, make sure you have the below documents ready for upload:',
		companyAccountConsentDocumentsList1:
			'Account holder`s government-issued photo ID',
		companyAccountConsentDocumentsList2: 'Account holder`s proof of residence',
		applicationFormAccountCheck:
			'*I agree to let Tradeview Ltd. electronically verify my identity by providing my personal information, including identity documents. This information will be shared with a trusted identity verification service provider to confirm its accuracy and match it with the data they hold or obtain from other reliable sources.',

		//Company Consent
		companyConsentTitle:
			'Thanks for your interest! Let`s begin your application',
		companyConsentDescription:
			'In order to set up your corporate account, we need some information from you.',
		companyConsentDocumentsTitle:
			'Get the following documents ready before starting:',
		companyConsentDocumentsOfCompanyTitle: 'Company',
		companyConsentDocumentsList1: 'Articles of incorporation',
		companyConsentDocumentsList2: 'Certificate of incorporation',
		companyConsentDocumentsList3: 'Corporate bank statement',
		companyConsentDocumentsList4: 'Corporate proof of address',
		companyConsentDocumentsList5: 'Corporate resolution',
		companyConsentDocumentsList6:
			'Memorandum of association/articles of association',
		companyConsentDocumentsList7: 'Shareholder breakdown',
		companyConsentDocumentsOfAccountHolderTitle: 'Account holder',
		companyConsentDocumentsOfAccountHolderList1: 'Government-issued photo ID',
		companyConsentDocumentsOfAccountHolderList2: 'Proof of residence',
		companyConsentDocumentsOfShareholderTitle: 'UBO/Shareholder',
		companyConsentDocumentsOfShareholderList1: 'Company shareholder agreement',
		companyConsentDocumentsOfShareholderList2:
			'Company shareholder certificate',
		companyConsentAdditionalInfoDescription:
			'You can upload the documents you currently have handy; only a proof of address and identification are required to begin the process. All other documents can be uploaded or emailed later.',
		applicationFormConsentCheck:
			'*I agree to let Tradeview Ltd. electronically verify my identity by providing my personal information, including identity documents. This information will be shared with a trusted identity verification service provider to confirm its accuracy and match it with the data they hold or obtain from other reliable sources.',

		//Account holder details
		accountHolderDetailsTitle: 'Account holder details',
		shareHolderDetailsTitle: 'Account holder details',
		accountHolderDetailsTooltip:
			'The account holder is the primary individual responsible for managing the corporate account. This person executes trades, makes account decisions, and has the authority to add or remove shareholders. Ensure the account holder details accurately represent the key decision-maker for your corporate activities.',

		//Account holder address
		accountHolderAddressTitle: 'Account holder address',
		accountHolderAddressTooltip:
			'Provide the residential address of the account holder, the individual managing the corporate account. This information pertains to the account holder, not the company itself.',

		//Account holder tax residency declaration
		accountHolderTaxResidencyTooltip:
			'Provide the tax residency information of the account holder, the individual managing the corporate account. This information pertains to the account holder, not the company itself.',
		accountHolderTaxResidencyModalDescription:
			'We`re sorry. Due to regulation, we cannot provide services to companies based or people residing in the US territory.',

		//Account holder trading experience
		accountHolderTradingExperienceDescription:
			'Select the option that best represent your individual experience trading Forex, Stocks, Futures, Derivatives or CFDs.',

		//Shareholder consent
		shareholderConsentTitle:
			'Great! the account holder informations in now complete. Don`t loose momentum.',
		shareholderConsentDescription1:
			'We`re almost done. We only need to enter the shareholders information.',
		shareholderConsentDescription2:
			'If needed, you can edit the previously provided details at any point using the progress list on the right side of the screen. Simply click on the pencil icon next to the information you`d like to edit.',
		shareholderConsentDescription3:
			'Keep in mind that, apart from the Government-issued photo ID and proof of residence documents, you can upload the necessary documents at your convenience—either now or later when requested.',
		companyConsentConsentDocumentsTitle:
			'Before you begin, please ensure you or the shareholders have the following mandatory documents ready:',
		companyConsentConsentDescription1:
			"We're almost there! Just enter the shareholders' information to complete the process.",
		companyConsentConsentDescription2:
			"If needed, you can edit any details you've previously entered by clicking the pencil icon in the right column.",
		shareholderConsentDocumentsTitle:
			'Before starting, each shareholder should prepare the following mandatory documents:',
		shareholderConsentDocumentsList1:
			'Shareholder`s government-issued photo ID',
		shareholderConsentDocumentsList2: 'Shareholder`s proof of residence',
		shareholderConsentDocumentsList3: 'Digital signature',
		shareholderConsentCheck:
			'*I agree to let Tradeview Ltd. electronically verify my identity by providing my personal information, including identity documents. This information will be shared with a trusted identity verification service provider to confirm its accuracy and match it with the data they hold or obtain from other reliable sources.',

		//Application Submition
		applicationSubmitionTitle: 'Application submission',
		applicationSubmitionDescription1:
			'Your corporate account application is almost done! We appreciate the effort made in completing the application.',

		applicationSubmitedTitle:
			'Corporate application submitted: Review in progress',
		applicationSubmitedDescription1:
			'Thank you for submitting your corporate account application. Your request is now under review and will be verified shortly.',
		applicationSubmitedDescription2:
			'Our operations team will reach out to you if you choose not to upload any of the requested documents during the information fill-in.',
		//Global
		selectOption: 'Select an option',
		accountOwnershipTooltip:
			'This refers to the country where your business is primarily located. Accurate information helps us customize our services based on regional requirements and regulations. If your country of location is not listed in the options, we regret to inform you that we are unable to offer our services in your location.',

		//Progress
		companyInformation: 'Company Information',
		companyAddressDetails: 'Company address details',
		companyOwnershipDetails: 'Company ownership details',
		companyDocuments: 'Company documents',
		accountConsent: 'Account consent',
		accountConsentCorporate: 'Account holder information',
		tradingExperience: 'Trading Experience',
		accountInformation: 'Account Information',
		IDVerification: 'ID Verification',
		accSetupSubmision: 'Account setup and submission',
		shareholderInformation: 'Shareholder Information',
		shareholderConsent: 'Shareholder consent',
		finish: 'Finish',
		addressDetails: 'Address details',
		share: 'Share',

		//Shareholder consent
		welcomeShareholderConsentTitle:
			'Ready to join your corporate account? Let`s begin your application',
		welcomeShareholderConsentDescription1:
			'In order to set up your corporate account, we need some information from you.',
		welcomeShareholderConsentDocumentsList1: 'Government-issued photo ID',
		welcomeShareholderConsentDocumentsList2: 'Proof of residence',
	},

	//disclaimer
	disclaimer: {
		secure1: 'SECURE',
		secure2: 'SSL ENCRYPTION',
		secure3: '',
		term: 'Terms and Conditions',
		privacy: 'Privacy Policy',
		aml: 'AML Policy',
		withdrawal: 'Withdrawal Policy',
		refund: 'Refund Policy',
		risk: 'Risk Disclosure',
		title: 'Disclaimer',
		default: {
			description:
				'The services and products offered by Tradeview Markets are not being offered within the United States (US) and not being oﬀered to US Persons, as defined under US law. The information on this website is not directed to residents of any country where FX and/or CFDs trading is restricted or prohibited by local laws or regulations. CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. Between 74% - 89% of retail investors’ accounts lose money when trading CFDs. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.',
		},
		ltd: {
			description:
				'The services and products offered by Tradeview Ltd. are not being offered within the United States (US) and are not being offered to US Persons, as defined under US law. The information on this website is not directed to residents of any country where FX and/or CFDs trading is restricted or prohibited by local laws or regulations. CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. Between 74% - 89% of retail investors’ accounts lose money when trading CFDs. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.',
		},
		latam: {
			description:
				'The services and products offered by Tradeview Financial Markets S.A.C. are not being offered within the United States (US) and are not being offered to US Persons, as defined under US law. The information on this website is not directed to residents of any country where FX and/or CFDs trading is restricted or prohibited by local laws or regulations. CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. Between 74% - 89% of retail investors’ accounts lose money when trading CFDs. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.',
		},
		mena: {
			description:
				'The services and products offered by Tradeview Financial Markets S.A.C. are not being offered within the United States (US) and are not being offered to US Persons, as defined under US law. The information on this website is not directed to residents of any country where FX and/or CFDs trading is restricted or prohibited by local laws or regulations. CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. Between 74% - 89% of retail investors’ accounts lose money when trading CFDs. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.',
		},
	},

	//modal
	modal: {
		error: "You can't continue with your application",
		description:
			"We're sorry. Due to regulation, we cannot provide services to people residing in the US territory.",
		thank: 'Thanks for your interest in joining Tradeview.',
		btnRegulation: 'Visit regulation page',
	},

	//tooltips
	tooltips: {
		signature1:
			"Choose how you'd like to upload your signature. You can either use our signature upload feature or draw your signature directly using our interactive tool. Select your preferred method below.",
		sourceAccount: 'The account from which the funds will be withdrawn.',
		sourceAccountTransfer:
			'The account from which the funds will be transferred.',
		currencyUSD: 'USD: USA Dollar',
		currencyEUR: 'EUR: Euro',
		currencyJYP: 'JPY: Japan Yen',
		currencyCAD: 'CAD: Canada Dollar',
		currencyGBP: 'GBP: Great Britain Pound',
		targetAccount: 'The account that will receive the transferred funds.',
		digitalWallets:
			'For your convenience, we take a wide selection of ewallet options. Please note that fees may vary depending on the Funding method you choose.',
		wireTransfers:
			"With this deposit method, you'll need to select your bank, provide the required information, initiate the transfer, and your funds will be available shortly after validation from your broker.",
		cardTransfers:
			'We accept Visa, Mastercard and Apple Pay for your credit card deposits. ',
		currencyUphold: `Currency refers to the primary currency in which your account will execute trade. It is represented using the following abbreviations:<br/>USD: USA Dollar <br/>EUR: Euro <br/>JPY: Japan Yen <br/>CAD: Canada Dollar <br/>AUD: Australia Dollar <br/>CHF: Switzerland Franc <br/>GBP: Great Britain Pound <br/>MXN: Mexico Peso <br/>ZAR: South Africa Rand`,
		currencyType:
			"Currency is the primary form of payment you'll be using in your account.",
		leverageTM:
			'Leverage enables you to control larger positions than your initial capital allows, typically expressed as ratios like 1:500 or 1:100, showing the equities you can control compared to your own deposit.',
		demoXleverage: 'X-Leverage: 1:400',
		demoILC: 'ILC: 1:200',
		demoStock: 'Stock: 1:1',
		notSureAccount:
			'Not sure which account type to choose? You can review them ',
		ltd: {
			withdrawCurrency:
				'Currency refers to the primary currency in which your account will execute trade. It is represented using the following abbreviations: <br><br> USD: USA Dollar <br> EUR: Euro <br> GBP: Great Britain Pound',
		},
		latam: {
			withdrawCurrency:
				'The primary currency in which your account will execute trade.',
		},
	},

	//register
	register: {
		goBack: 'Go back',
		titleRegister: 'Account Registration',
		AccountDesc:
			'Welcome to our trading portal! Choose between our Demo or Live accounts to start your trading journey and discover the Tradeview difference.',
		AccountChoose: 'What type of account would you like to create?',
		dinamicDescLive:
			'Not ready for a Live account yet? <spam>Create a Demo account.</spam> ',
		dinamicDescDemo:
			'Want to trade live instead? <spam>Create a Live account</spam>',
		getYour: 'Start trading now!',
		or: 'Or register here:',
		email: 'Email',
		secure: 'Create password',
		confirmPassword: 'Confirm password',
		disclaimer:
			"Disclaimer: Before opening an account it is our obligation at Tradeview Ltd. ('Tradeview') to ensure that You or the person/s appointed to trade on your behalf have the necessary knowledge and experience in CFD and related financial instruments. It is also our requirement to comply with AML and CFT obligations. In this regard you are kindly requested to provide accurate, complete and factual information as requested in line with this application and in order for us to complete compliance with the above obligations. On the basis of this information we are able to properly determine whether the investment services in connection with the financial instrument/s is/are appropriate to You. All Sections need to be completed. For further details please refer to our Client Agreement. For EU clients: By checking the box below, you are confirming that you have not been solicited by Tradeview or by any individual associated with Tradeview to open an account with the selected entity.",
		byTicking: 'By checking this box you agree to the disclaimer above.',
		getstarted: 'Continue',
		messageFooter1: 'The services and products offered by ',
		messageFooter2:
			' are not being offered within the United States (US) and are not being offered to US Persons, as defined under US law. The information on this website is not directed to residents of any country where FX and/or CFDs trading is restricted or prohibited by local laws or regulations. CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. Between 74% - 89% of retail investors’ accounts lose money when trading CFDs. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money. 74-89% of retail CFD accounts lose money. For further information regarding our fees please refer to this link.',
		client: 'Client Cabinet',
		instructionstitle1: 'Save time and effort!',
		instructionstitle2: 'A platform for every',
		instructionstitle3: 'need you have',
		options1f: 'Regulated',
		options1l: 'and safe ',
		options2f: 'Personalized',
		options2l: 'assistance',
		options3f: 'Unmatched',
		options3l: 'liquidity',
		haveAccount: 'Do you have an account?',
		signUp: ' Login',
		newCode: 'A one-time code was sent to',
		tryEgain:
			"We can't resend your code right now. Please try after some time.",
		invalidEmail: 'Invalid format. Please try again.',
		passwordRequired: 'This field is required. Please enter it.',
		invalidPassword:
			'Password must be at least 8 characters and include at least one lowercase, one uppercase, one number, and one special character.',
		confirmPasswordRequired: 'This field is required. Please enter it.',
		passwordsDoNotMatch: "Password don't match. Please try again",
		errorDisclaimer: 'Please check the acknowledgment checkbox to proceed',
		firstNameError: 'This field is required. Please enter it.',
		typeAccountError: 'Please select a type account',
		invalidName:
			'Your first name cannot have numbers or symbols. Please try again.',
		invalidLastName:
			'Your last name cannot have numbers or symbols. Please try again.',
		mfaCode: 'Enter MFA code',
		startDemo: 'Get your Free Demo Account now!',
		orRegister: 'Or register here:',
		verificationCode: 'Verification code',
		didntCode: "Didn't receive any code?",
		yourEmail: 'Your email',
		firstName: 'First name',
		lastName: 'Last name',
		accountType: 'Account type',
		accountCategory: 'Account category:',
		accountCategoryPlaceholder: 'Select an account category',
		accountCategoryTooltip: `<strong>Individual Account:</strong>  </br> Select this option if you are a single account holder. </br></br> <strong>Joint Account:</strong>  </br> Choose this option if you are opening an account with someone else, such as a spouse or business partner. </br></br> <strong>Corporate Account:</strong> </br> Opt for this option if you are representing an entity; business or organization. `,
		entity: 'Entity:',
		entityPLaceholder: 'Select an entity',
		entityTooltip:
			'We follow rigorous financial standards in all the jurisdictions we operate in. Find out more information here.',
		countryTooltip:
			'If your country of residence is not listed in the options, we regret to inform you that we are unable to offer our services in your location.',
		checkRegis:
			'By checking this box, I acknowledge  I have not been solicited by Tradeview or any individual associated with Tradeview to switch entities.',
		changeRegion: "Change to my region's entity",
		liveIndividual: 'Live individual account </br> Start trading now!',
		jointIndividual: 'Live joint account </br> Start trading now!',
		corporateIndividual: 'Live corporate account </br> Start trading now!',
		entityText:
			'You are about to select an entity for your account creation that is established and regulated in a region different from your selected country of residence.',
		accountRegis: 'Important notice',
		entityTextEu: `The website you are visiting now is operated by an entity that is not established in the European Union or regulated by an EU National Competent Authority.  <br><br>  By clicking on ‘Continue’ you are confirming that you have not been solicited by Tradeview or by any individual associated with Tradeview to switch entities. <br><br> To be directed to the European Union regulated entity, Tradeview Europe Ltd., please click on ‘Change to my region’s entity’. Tradeview Europe Ltd. is regulated by the MFSA, which is suitable for your jurisdiction.`,
		entitiesTitle: 'International entities trading under our bransd:',
		entitiesDesc: `<ul> <li> <b>Tradeview Ltd. (CIMA)</b> </li> </ul> <p>Regulated by the Cayman Islands Monetary Authority (CIMA) and operates under the Cayman Islands Laws (SIBL)</p>  <br> <ul> <li> <b>Tradeview Financial Markets S.A.C (Global)</b> </li> </ul> <p>Registered with SUNARP, operates under the General Law of Companies (LGS).</p> <br>`,
		entitiesDescEu: `<ul> <li> <b>Tradeview Ltd. (CIMA)</b> </li> </ul> <p>Regulated by the Cayman Islands Monetary Authority (CIMA) and operates under the Cayman Islands Laws (SIBL)</p>  <br> <ul> <li> <b>Tradeview Financial Markets S.A.C (Global)</b> </li> </ul> <p>Registered with SUNARP, operates under the General Law of Companies (LGS).</p> <br>`,
		individual: 'Individual',
		joint: 'Joint',
		corporate: 'Corporate',
		reloadPage:
			'Please refresh the page to continue. This will fix an issue preventing data entry.',
		instructionsIB1: 'Grow your brokerage',
		instructionsIB2: 'business– Become an IB',
		instructionsIB3: 'in less than 5 minutes!',
		titleIbRegister: 'New at Tradeview Markets?',
		disclaimerIBportal:
			'Disclaimer: Before opening an account it is our obligation at Tradeview Financial Markets S.A.C. (Tradeview) to ensure that You or the person/s appointed to trade on your behalf have the necessary knowledge and experience in CFD and related financial instruments. It is also our requirement to comply with AML and CFT obligations. In this regard you are kindly requested to provide accurate, complete and factual information as requested in line with this application and in order for us to complete compliance with the above obligations. On the basis of this information we are able to properly determine whether the investment services in connection with the financial instrument/s is/are appropriate to You. All Sections need to be completed. For further details please refer to our Client Agreement.',
		alreadyClient: 'Already a Tradeview client?',
		loginClientCabinet: ' Log in to your client Cabinet',
		registerIB: 'to register as an IB.',
		instructionsIBportal1: "We've got you covered!",
		instructionsIBportal2: 'Solutions for every',
		instructionsIBportal3: 'need you have',
		options1f_ib_portal: 'Turnkey client',
		options1l_ib_portal: 'solutions',
		options2f_ib_portal: 'Customer support',
		options2l_ib_portal: 'available 24/5',
		options3f_ib_portal: 'Daily payouts for rebates',
		options3l_ib_portal: 'and commissions',
		register_enjoy: 'Register now and enjoy:',
		fast_onboarding: 'Fast onboarding ',
		no_program: 'No upfront costs program',
		fast_solutions: 'Fast onboarding Turnkey client solutions',
	},
	brokerDetails: {
		personalBrokerDetails: 'Personal and broker details',
		verification: 'Verification',
		licenseOperate:
			'Are you licensed and registered to operate in your jurisdiction?',
		countryClients:
			'In which countries do the majority of your clients reside?',
		platformOffer: 'Which platform(s) will you be offering your clients?',
		markerOffer: 'Which types of markets will you offer your clients?',
		sizeofClient: 'What is the current size of your client base?',
		sourcesClient:
			'What are the main sources that drive your current client base?',
		website: 'Website (optional)',
		websitePlaceholder: 'Option',
		socialProfile: 'Social media profiles (optional)',
		socialProfilePlaceholder: 'Option',
		seekingClient: 'Are you currently seeking new clients?',
		pursingClientBeyond:
			'Is your team actively pursuing new clients in countries beyond your current operational scope?',
		countryPursingClients: 'In which countries?',
		receivedComplaint:
			'Have you received any client complaints regarding excessive trading in discretionary accounts?',
		receivedRegulationCountions:
			'Have you received any regulatory cautions from any jurisdictions in which you operate?',
		tradingAccount: 'Do you want to create a trading account?',
		sizeOption1: '0–15 clients',
		sizeOption2: '16–50 clients',
		sizeOption3: '51–200 clients',
		sizeOption4: '201–500 clients',
		sizeOption5: 'Over 500 clients',
		sourceOption1:
			'Digital marketing strategies (mailing, social media, SEO...)',
		sourceOption2: 'Friends and family',
		sourceOption3:
			'Networking strategies (affiliate marketing, events, webinars...)',
		sourceOption4: 'Referral programs',
		sourceOption5: 'Traditional marketing (phone calls, SMS...)',
		title: 'Broker details',
		description:
			'We want to gain insight of your business operations and client base. The information you provide is strictly confidential and will only be used for understanding your business.',
		descriptionComplaints:
			'We value transparency in our partnerships. In this section, we invite you to provide detailed information of any past complaints you or your company has received.',
		complaintsPastTwoYears:
			'In the past two years, how many complaints have you or your company has received?',
		complaintsOption1: '1–5 complaints',
		complaintsOption2: '6–10 complaints',
		complaintsOption3: 'Over 10 complaints',
		natureOfComplaints:
			'What is the nature of the complaints you or your company have received?',
		natureOption1: 'Unsatisfactory customer service',
		natureOption2: 'Delays and errors in trading execution',
		natureOption3: 'Unauthorized trades',
		natureOption4: 'Mishandling of accounts',
		natureOption5: 'Misleading information',
		natureOption6: 'Compliance and regulatory issues',
		natureOption7: 'Disputes related to financial transactions',
		natureOption8: 'Technical issues in trading platforms',
		natureOption9: 'Performance of investment advice',
		natureOption10: 'Security vulnerabilities',
		natureOption11: 'Others',
		selectOption: 'Select an option',
		selectAllThatApply: 'Select all that apply',
		disciplinaryAction:
			'Have you or your brokerage faced any disciplinary actions from regulatory agencies?',
		descriptionDisciplinaryAction: 'What disciplinary actions were taken?',
		actionOption1: 'Warning',
		actionOption2: 'Fines',
		actionOption3: "Restrictions on the broker's operations",
		actionOption4: "Revocation of the broker's license",
		actionOption5: "Suspension of the broker's license",
		actionOption6:
			'Request for additional training or education for the broker or their team',
		actionOption7: "Changes to the broker's policies or procedures",
		actionOption8:
			'Request for restitution or compensation to the affected clients',
		actionOption9:
			'Referral of the case to law enforcement for further investigation or prosecution',
		actionOption10: 'Other',
	},
	'reset-password': {
		instructionstitle1: 'Save time and effort!',
		instructionstitle2: 'A platform for every',
		instructionstitle3: 'need you have',
		title: 'Set a new password',
		label1: 'New password',
		label2: 'Confirm password',
		options1f: 'Regulated',
		options1l: 'and safe',
		options2f: 'Personalized',
		options2l: 'assistance',
		options3f: 'Unmatched',
		options3l: 'liquidity',
	},

	//Calendar
	calendar: {
		title: 'Calendar',
	},

	wellcomeIBComponent: {
		title: 'Welcome to your Introducing Broker Individual account application',
		titleCurrent: 'Welcome to your Introducing Broker individual application',
		subTitle:
			'Thank you for your interest in collaborating with us to develop your business even further. You are about to provide the necessary information to set up your account for referring clients and receiving volume-based payouts.',
		before: 'Before starting, prepare the following documents:',
		government: 'Government-issued photo ID',
		proof: 'Proof of residence',
		agree:
			'* I agree to let Tradeview Financial S.A.C. electronically verify my identity by providing my personal information, including identity documents. This information will be shared with a trusted identity verification service provider to confirm its accuracy and match it with the data they hold or obtain from other reliable sources.',
		marketing: '/ I/we agree to be included in our marketing distribution list',
		btnContinue: 'Continue',
		checkError: 'Check the box to agree to the information treatment.',
	},

	//application process
	application: {
		selectAllThatApply: 'Select all that apply',
		editing: 'Editing',
		optional: '(Optional)',
		ifApplicable: '(if applicable)',
		taxResTitle: 'Your tax residency declaration',
		taxResPurposes: 'Are you a US Citizen or a US Resident for tax purposes?',
		taxLabelCompany:
			'The company hereby confirms that, for tax purposes, it is a resident in the following country:',
		taxLabelIndividual:
			'I hereby confirm that I am, for tax purposes, a resident in the following country:',
		taxResHereby:
			'I hereby confirm that I am, for tax purposes, a resident in the following country:',
		taxResCountryL: 'Country',
		taxResCountryP: 'Select a country',
		taxResMarketL: 'Tax reference code',
		jobTitleL: 'Job title',
		jobTitleP: 'Enter your job title',
		taxResMarketP: 'Enter your tax reference code',
		taxResMarketTM:
			"Your tax reference code may consist of a combination of letters and numbers, it may also be entirely numeric. Rest assured, your information is secure with us. We're obligated to request this information by the OECD's reporting standards. You can learn more about it. <a href='https://www.oecd.org/tax/automatic-exchange/common-reporting-standard/' target='_blank'>here</a>",
		taxResPoliticalL:
			'Are you a politically exposed person (PEP), close relative or associate of a PEP?',
		taxResPoliticalTM:
			'A PEP (Politically Exposed Person) is a person who holds or has held a prominent public position, with potential implications for financial risk assessment.',
		taxResStatusL: "What's your PEP status or how are you related to a PEP?",
		taxResStatusP:
			'Please, provide us with details of your PEP status or relationship.',
		taxResStatusTM:
			'You are required to disclose your PEP status or any related connections to address risks adequately for both parties (you and Tradeview). Nevertheless, please rest assured that if you are a PEP or have any associations with one, you are still welcome to proceed with your application process.',
		taxCode: 'Tax reference code',
		shareholdersIncomplete: 'Shareholders Information Incomplete',
		shareholdersIncompleteDesc:
			'Please ensure all shareholders have completed their information before proceeding.',
		previousStepsRequired: 'Previous steps required to continue',
		previousStepsRequiredDesc:
			'Please finish the required step(s) before proceeding to Proof of Residence.',
		personalDetailsIncomplete: 'Personal Details incomplete',
		personalDetailsIncompleteDesc:
			'Please complete the Personal Details step before proceeding.',
		idVerificationIncomplete: 'ID Verification incomplete',
		idVerificationIncompleteDesc:
			'Please complete the ID Verification step before proceeding.',
		unableToSubmit: 'Unable to submit',
		unableToSubmitDesc:
			'You must complete all required steps in the correct order to proceed.',
		taxCodeTooltip: `Your tax reference code may consist of a combination of letters and numbers, or it may be entirely numeric. Your information is secure with us. We are required to collect this information according to OECD reporting standards. You can learn more about it <a href="https://www.oecd.org/tax/automatic-exchange/common-reporting-standard/" target="_blank" rel="noopener noreferrer">here</a>.`,
		selectTaxCode: 'Enter your tax reference code',
		accountTypeH: 'Your account type',
		accountTypeD:
			'After creating your first Tradeview account, you can easily open more accounts for different financial assets without the need to fill out the entire form again.',
		tradingMarketL: 'Trading market',
		tradingMarketP: 'Select market',
		tradingMarketTM:
			"A trading market is the market or exchange where an asset or instrument is listed or quoted for trading. <br><br> Not sure which market to choose? You can review them <a href='https://www.tvmarkets.com/trading/markets' target='_blank'>here</a>",
		currencyTypeL: 'Currency type',
		currencyTypeP: 'Select a currency type',
		currencyTypeTM:
			"Currency is the primary form of payment you'll be using in your account. It is represented using the following abbreviations: <br><br> USD: USA Dollar <br> EUR: Euro <br> JPY: Japan Yen <br> CAD: Canada Dollar <br> AUD: Australia Dollar <br> CHF: Switzerland Franc <br> GBP: Great Britain Pound <br> MXN: Mexico Peso",
		platformL: 'Platform',
		platformP: 'Select platform',
		platformTM:
			"A platform is a software system offered to operate assets or instruments. <br><br> Not sure which platform to choose? You can review them <a href='https://www.tvmarkets.com/trading/platforms' target='_blank'>here</a>",
		accountTypeL: 'Account type',
		accountTypeP: 'Select account type',
		accountTypeTM:
			"The account type allows you to select the leverage you can get in your account <br><br> X-Leverage: 1:400<br> ILC: 1:200<br> Stock: 1:1 <br><br> Not sure which account type to choose? You can review them <a href='https://www.tvmarkets.com/trading/accounts' target='_blank'>here</a>",
		emplymentAditionalDetails: 'Aditional information',
		emplymentDetailsH: 'Your employment details',
		employmentStatusL: 'Employment status',
		employmentStatusP: 'Select a status',
		employerL: 'Employer',
		employerP: 'Enter your employer name',
		occupationL: 'Occupation',
		occupationP: 'Enter your occupation',
		industryL: 'Industry',
		industryP: 'Select a nature of your business',
		industryTM:
			"Industry describes the fundamental characteristics and activities of the company you're employed by.",
		employmentTypeL: 'Employment type',
		employmentTypeP: 'Select a nature of employment',
		employmentTypeTM:
			'Employment type describes the fundamental characteristics and conditions that define your work arrangement or job status',
		employmentAddressL: 'Employer address',
		employmentAddressP: 'Enter your employement address',
		employerCountryL: 'Employer country',
		employerCountryP: 'Select a country',
		employerProvinceL: 'Employer province',
		employerProvinceP: 'Select a province',
		employerCityL: 'Employer city',
		employerCityP: 'Select a city',
		employerZipL: 'Employer ZIP/postal code',
		employerZipP: 'Enter your employer zip/postal code',
		businessTypeL: 'Business type',
		businessTypeP: 'Select a type of business',
		businessTypeTM:
			'Business types refer to the various legal structures and forms that organizations or enterprises can take when operating in the business world.',
		businessCountryL: 'Business country',
		businessCountryP: 'Select a country',
		businessProvinceL: 'Business province',
		businessProvinceP: 'Select a province',
		businessCityL: 'Business city',
		businessCityP: 'Select a city',
		businessLocationL: 'Business location',
		businessLocationP: 'Enter your business address',
		businessNameL: 'Business name',
		businessNameP: 'Enter your business name',
		businessWebL: 'Business website',
		businessWebP: 'Enter your business website url',
		businessIndustryL: 'Industry',
		businessIndustryP: 'Select a nature of your business',
		businessIndustryTM:
			"Industry describes the fundamental characteristics and activities of the company you're employed by.",
		financialDetailsH: 'Your financial details',
		annualIncomeL: "What's your annual income?",
		totalAssetsL: "What's your total assets balance?",
		totalAssetsTM:
			'Your assets balance is the value of your savings, investments, real estate properties after deducting commitments.',
		liquidAssetsL: "What's your liquid assets balance?",
		liquidAssetsTM:
			'Your liquid assets balance is the sum of your cash, money, market instruments, and marketable securities.',
		tradeAnnuallyL: 'How much do you plan to invest/trade annually?',
		originAssetsL: "What's the origin of your total assets?",
		originDepositsL: "What's the origin/source of your deposits/funds?",
		purposeAccountL: "What's the purpose of the account?",
		bankruptciesDetailsL: 'Bankruptcies details',
		bankruptciesDetailsP:
			"Add information about bankruptcies you're connected with",
		bankruptciesDetailsTM:
			'You are required to disclose any bankruptcy affiliations to address risks for both parties (you and Tradeview). <br><br> Nevertheless, please rest assured that if you are connected to any bankruptcy, you are still welcome to proceed with your application process',
		bankruptciesConnetL: 'Are you connected to bankruptcies?',
		tradingExperienceH: 'Your trading experience',
		tradingExperienceD:
			'Select the option that best represent your experience trading Forex, Stocks, Futures, Derivatives or CFDs.',
		tradingExperienceDMENA:
			'Select the option that best represent your experience trading Forex, Stocks, Derivatives or CFDs.',
		tradingExperienceTM:
			"We ask about your trading experience to help us provide personalized support, guidance, and an optimal trading experience, whether you're a seasoned trader or just getting started.",
		yearsTradingL: 'How many years have you been trading?',
		yearsTradingP: 'Select an option',
		tradingVolumenL: "What's your trading volume?",
		tradingVolumenP: 'Select an option',
		oftenTradeL: 'How often do you trade?',
		oftenTradeP: 'Select an option',
		identityH: 'Your identity verification',
		identityHShareholder: 'Shareholder identity verification',
		identityDesc:
			'To complete the verification, you will need one of the following documents:',
		identityDescShareholder:
			'The ID verification process is essential for preventing fraud and ensuring the responsible and lawful use of our services. We sincerely appreciate your cooperation.',
		identityD:
			'This step is mandatory. We suggest completing it on a mobile device using the QR code below for a smoother experience.',
		identityVerifiedH: 'Identity verification submitted',
		identityVerifiedDesc:
			'Document uploaded successfully. You can continue to the next step.',
		identityDLatam:
			'For a smoother experience, we suggest completing this step on your phone using the QR code below. You’ll need one of the following documents to perform the verification: ',
		idDocumentL: 'Identity document',
		idDocumentP: 'Select a type of document',
		idDocumentTM:
			"Document type refers to the types of ID you can use to confirm your identity for a secure trading experience. We accept the following: <br> <br> Passport (Suggested)<br> Identity Card<br> Residence Permit<br> Driver's License",
		idDocumentUploadL: 'Document upload ',
		idDocumentUploadTM:
			'Make sure information and images in the file are clear and understandable.',
		idDocumentFrontL: 'Front side',
		idDocumentFrontTM:
			'Front of your ID displays your photo, full name, and ID number.',
		idDocumentBackL: 'Back side',
		idDocumentBackTM:
			'Back of your ID contains additional information, such as your address or other relevant details.',
		proofResidenceH: 'Proof of residence',
		proofResidenceHYour: 'Your Proof of residence',
		proofResidenceD:
			'Confirm your location to ensure compliance with regulatory standards.',
		proofResidenceDShareholder:
			'Confirm the shareholder’s location to ensure compliance with regulatory standards.',
		proofResidenceL: 'Proof of residence document',
		proofResidenceP: 'Select a document type',
		proofResidenceTM:
			'To verify your address, please provide one of these documents: <br><br>  • Utility bill  <br>  • Bank statement (with transaction history) <br> • Certificate of residency     <br><br>   Accepted utility bills include:    <br>• Gas    <br>• Electricity  <br>  • Water  <br>  • Landline phone  <br>  • Internet (if connected to the residence)  <br>  • Cable (if connected to the residence)  <br><br>    We do not accept mobile phone bills or bank statements showing large cash deposits.',
		proofUploadL: 'Document upload ',
		proofUploadTM:
			'Make sure the document: <br><br> • Is no older than 3 months <br>• Includes your name <br>• Has an address that match with the one in your application <br>• Is not a screenshot <br>• Is not cut-off <br>• Doesn’t have blocked/masked information <br>• Has a translatable language',
		addressDetail: 'Address',
		financialDetailsTM:
			'You are required to disclose your financial details to address risks properly for both parties (you and Tradeview).',
		acknowledgementH: 'Acknowledgement',
		acknowledgementCheck:
			'By checking this box, I acknowledge I have read, understand and agree to all the information contained in the listed documents above.',
		signatureH: 'Signature',
		signatureP1:
			'By signing below and clicking on ‘Submit’ I acknowledge and agree, under penalty of perjury, that all information provided in the application is true and accurate and all deposits into my account, regardless of origination source, type of currency, or method of deposit, are not the proceeds of criminal or illegal activity and are derived from legitimate sources.',
		signatureP2:
			'Also, I further acknowledge and agree, under penalty of perjury, that all information provided in the application is true and accurate and all deposits into my account, regardless of origination source, type of currency, or method of deposit, are not the proceeds of criminal or illegal activity and are derived from legitimate sources.',
		signatureMethod: 'Which signature method would you like to use?',
		signatureDraw: 'Draw signature',
		signatureUpload: 'Upload signature',
		signatureTM:
			"Choose how you'd like to upload your signature. You can either use our signature upload feature or draw your signature directly using our interactive tool. Select your preferred method below.",
		signatureAD: 'Authorised client signature, sign above',
		additionalRiskH: 'Additional risk disclosure',
		additionalRiskD1:
			'The information provided on your account application indicates that you do not meet Tradeview Ltd. guidelines to open a trading account for one of the following reasons:',
		additionalRiskP1Latam:
			'In addition to the standard industry disclosures included in the Tradeview Markets Client Account Agreement, you should be aware that forex trading is considered a risky form of investment. If you have pursued only conservative forms of investment in the past, you may wish to study forex trading further before continuing an investment of this nature.',
		additionalRiskP2Latam:
			'If you wish to continue with your investment, you acknowledge that the funds you have committed are purely risk capital and loss of your investment will not jeopardize your style of living nor will it detract from your future retirement program. Additionally, you fully understand the nature and risks of forex investments, and your obligations to others will not be neglected should you suffer investment losses.',
		additionalRiskUl1: 'You are not between 21 and 63 years old',
		additionalRiskUl2: 'Your annual income is below $25,000 USD',
		additionalRiskUl3: 'You have filed for bankruptcy within the last year',
		additionalRiskUl4: 'You are not employed',
		additionalRiskD2:
			'While Tradeview Ltd. is prepared to open your account, it is necessary to advise you to reconsider this investment. Based on your personal information and/or investment experience, forex might be too risky of an investment strategy. The loss in trading forex can be substantial. You should therefore carefully consider whether such trading is suitable for you in light of your circumstances and financial resources. The high degree of leverage that is obtainable in forex trading because of the small margin requirements can work against you as well as for you. The use of leverage can lead to large losses as well as gains.',
		additionalRiskChk1:
			'I understand that I do not meet the minimum guidelines to open an account as set forth by Tradeview Ltd. in the above paragraphs. However, I have considered the financial risks involved in forex trading with regard to my personal situation, and I wish to proceed with opening an account.',
		additionalRiskChk2:
			'I acknowledge that I have read the above and fully understand the information provided herein.',
		additionalRiskChk1Latam:
			'I am aware of the inherent risks associated with my trading account and have considered all the possible consequences of losing my investment. Having read the risks associated with forex trading, I am willing to proceed with the account opening process.',
		additionalRiskChk2IB:
			'I acknowledge and agree, under penalty of perjury, that all information provided in the application is true and accurate.',
		additionalRiskChk2Latam:
			'I acknowledge that I have read the above and fully understand the information provided herein.',
		submitApplicationH: 'Submit application',
		submitApplicationD1:
			"You're almost there! We appreciate your effort in completing your application.",
		submitApplicationD2:
			"When you're ready, simply click the submission button below to send it in.",
		submitApplicationD3:
			"If you have any questions or need assistance, please don't hesitate to",
		submitApplicationLink: 'contact us.',
		submitApplicationCheck:
			'I/We agree to be included in our marketing distribution list',
		applicationSubmitedH: 'Application submitted: Review in progress',
		applicationSubmitedD1:
			'Thank you for submitting your account application. Your request is now under review and will be verified shortly.',
		applicationSubmitedD2:
			'Our operations team will reach out to you if any further documentation is required.',
		applicationSubmitedD3:
			'We appreciate your cooperation and will keep you updated on the progress.',
		applicationSubmitedIB1:
			'Thank you for submitting your Introducing Broker account application. Your request is now under review and will be verified shortly.',
		applicationSubmitedIB2:
			'Our team will contact you if any additional documentation is required.',
		applicationSubmitedIB3:
			'We appreciate your cooperation and will keep you updated on the progress via email. In the meantime, you can access your client Cabinet to manage your trading account(s). ',
		applicationSubmitedIB: 'Go to Cabinet',
		applicationSubmitedGT: 'Go to my cabinet',
		applicationSubmitedET: 'Explore Tradeview',
		apEmailL: 'Email',
		apFirstNL: 'First name',
		apFirstNP: 'First name',
		apLastNL: 'Last name',
		apLastNP: 'Last name',
		apDateBL: 'Date of birth',
		apCountryBL: 'Country of birth',
		apCountryBP: 'Select a Country',
		apCountryNL: 'Nationality',
		apCountryNP: 'Select a nationality',
		apMobileL: 'Mobile (Optional)',
		apMobileLReq: 'Mobile',
		apPhoneL: 'Phone',
		apPassL: 'ID/Passport number/SIN',
		apPassP: 'Enter your ID, passport or SIN',
		apPassT:
			'You only need to enter one of the identification documents. Keep in mind that SIN (Social Insurance Number) is only required for users in Canada.',
		apPassDL: 'ID/Passport/SIN expiration date',
		apGenderL: 'Gender',
		apGenderP: 'Select an option',
		apMaritalL: 'Marital Status',
		apMaritalP: 'Select an option',
		apCountryRL: 'Country of location',
		apCountry: 'Country',
		apCountryRLTooltip: `This refers to the country where your business is primarily located. Accurate information helps us customize our services based on regional requirements and regulations.
							
		If your country of location is not listed in the options, we regret to inform you that we are unable to offer our services in your location.`,
		apCountryRLResidence: 'Country of residence',
		apCountryRP: 'Select a Country',
		apProvinceRL: 'State/Province',
		apProvinceRP: 'Select a province',
		apCityRL: 'City',
		apCityRP: 'Select City',
		apStreethRL: 'Street name',
		apStreethRD: 'Enter your street name',
		apStreethNL: 'Street number',
		apStreethND: 'Enter your street number',
		apPostCL: 'Post code',
		apPostCD: 'Enter your post code',
		appAddresT:
			'If your country of residence is not listed in the options, we regret to inform you that we are unable to offer our services in your location',
		modalCompleteT: 'All the information has',
		modalCompleteT2: 'been completed!',
		modalCompleteP:
			'We have all the necessary information to complete the process. The final step is to add the signature of the account holder and submit the application. Your journey is almost complete!',
		modalRegulationT: 'You cant continue with',
		modalRegulationT2: 'your application',
		modalRegulationP:
			"We're sorry. Due to regulation, we cannot provide services to people residing in the US territory.",
		modalRegulationPLTD:
			"We're sorry. Due to regulation, we cannot provide services to people residing in the United States.",
		modalRegulationP2: 'Thanks for your interest in joining Tradeview.',
		signatureTM2:
			'Please ensure the signature matches the one on your previously uploaded documents. Accepted file formats are: jpg, jpeg, and png, with a maximum file size of 2MB.',
		submitModal:
			'We detect some errors on the form, please review and try again or if the problem persist please contact our support team.',
		areaPH: 'Area',
		phonePH: 'Enter your number',
		emailPH: 'Enter your email',
		errorUpload: 'Please upload a file in a valid format and size.',
		apBtnContinue: 'Continue',
		apBtnSubmit: 'Submit',
		apBtnBack: 'Back',
		apBtnRegulation: 'Visit regulation page',
		complete: 'Complete',
		pending: 'Pending',
		rejected: 'Rejected',
		accepted: 'Accepted',
		enterFirstName: 'Enter a first name',
		enterLastName: 'Enter a last name',
		enterAnEmail: 'Enter an email',
		sendInvitation: 'Send invitation',
		invitationSent: 'The invitation has been sent successfully!',
		invitationSentDesc:
			'You can track down the application progress on the Secondary holder addition page.',
		modifiedInvitation:
			'Secondary account holder information updated successfully',
		modifiedInvitationDesc:
			'An invitation has been sent to the email address you provided for the secondary account holder. You can track the progress of the application on the Secondary holder addition page.',
		notModifiedInvitation:
			'Secondary account holder information updated successfully',
		notModifiedInvitationDesc:
			'You can track down the application progress on the Secondary holder addition page.',
		resend: 'Resend invitation',
		saveShareholder: 'Save shareholder',
		shareholderToComplete: 'Invite shareholder to complete',
		companyDocuments: 'Company documents verification',
		companyDocumentsDesc:
			'Verify your account, ensuring compliance and tailoring our services to your business needs.',
		documentUpload: 'Document upload',
		documentUploadTooltip1:
			'Make sure the information and images in the file are clear and understandable.',
		documentUploadTooltip2:
			"Feel free to upload the documents you have at the moment. Don't worry if some are missing; you can upload or send them later upon request.",
		documentUploadDesc:
			'Select whether to upload documents now or save for later. if opting to upload now, conveniently drag and drop your files or browse through your folders',
		articlesIncorp: 'Articles of incorporation',
		certificateIncorp: 'Certificate of incorporation',
		shareholderBreak: 'Shareholder breakdown',
		corporateBank: 'Corporate bank statement',
		memorandumArticles: 'Memorandum of association/articles of association',
		uploadNow: 'Upload now?',
		imageType:
			"Make sure the file is JPEG, PNG, or PDF format and it's size doesn't exceed 2 MB.",
		inviteConfirmation: 'Ready to send all your invitations?',
		inviteConfirmationDesc:
			"One mail will be sent to all the shareholders you want to add to your account. Once sent you'll not be able to add more shareholders.",
		inviteSent: 'Invitations have been sent successfully!',
		inviteSentDesc:
			'You can track down the application progress of each shareholder on the shareholder addition page.',
		deleteHolder: 'Are you sure you want to delete this shareholder?',
		deleteHolderDesc:
			"You're about to eliminate one of the shareholders linked to you corporate account. Do you want to proceed?",
		unableToContinue: 'Unable to continue',
		unableToContinueDesc:
			'The email address you provided is already associated with an account at Tradeview. Please provide another email to continue.',
		provideAnother: 'Provide another email address',
		duplicated: 'Duplicated',
		duplicatedDesc:
			'The email address is already associated with a Tradeview account. Please provide a different email to continue.',
	},

	//validations yup app process
	yup: {
		selectOption: 'Please select an option',
		phone: 'Your phone number cannot have letters or symbols.',
		phoneValid: 'Please use a valid number',
		dateofBirth: 'Please enter your date of birth',
		validEmail: 'Please enter a valid email',
		mustBeAdult:
			'Please enter a valid date of birth. You must be over 18 years old to continue.',
		passport: 'Please enter your identification number',
		passportValid: 'Please use a valid number',
		passportexpirationdate: 'Please enter a valid date',
		passportexpirationdateValid:
			'Please enter a valid expiration date. Only current documents are accepted',
		streetname: 'Please enter your street name',
		streetnumber: 'Please enter your street number',
		postcode: 'Please enter your post code',
		taxReference:
			'Your tax reference code cannot contain blank spaces or symbols. Please try again.',
		pepstatus: 'Please enter the requested information',
		pepstatusValid: 'Exceed maximum of characters',
		employer: 'Please enter your employers name',
		occupation: 'Please enter your occupation',
		employerAddress: 'Please enter your employer address',
		employerpostalcode: 'Please enter your employer ZIP/postal code',
		businesstype: 'Please enter your business type',
		industry: 'Please enter your business industry',
		business_location: 'Please enter your business address',
		business_name: 'Please enter your business name',
		business_website: 'Please enter your business website url',
		bankruptciesdetails: 'Please write your bankruptcy affiliations details.',
		acknowledgement: 'Please check the acknowledgment checkbox to proceed',
		agree: 'Please check the box to proceed',
		expirationDate: 'Invalid passport expiration date',
		invalidEmail: 'Invalid email format',
		EmailRequired: 'Email is required',
		companyName: "Please enter the parent company's name",
		email: 'Please enter your corporate email',
		businessDescription: 'Please enter the requested information',
		required: 'This field is required',
		jobTitle: 'Please enter your job title',
		emailAlreadyRegistered:
			'The entered email is already registered. Please use a different one.',
	},

	//helper arrays app proces
	array: {
		usd: 'USD',
		eur: 'EUR',
		gbp: 'GBP',
		female: 'Female',
		male: 'Male',
		noBinary: 'Non binary',
		other: 'Other',
		noAnswer: 'I prefer not to answer',
		single: 'Single',
		married: 'Married',
		divorced: 'Divorced',
		windowed: 'Windowed',
		registered: 'Registered partnership',
		yes: 'Yes',
		no: 'No',
		employed: 'Employed',
		selfEmployed: 'Self-Employed',
		retired: 'Retired',
		unemployed: 'Unemployed',
		aerospaceAndDefense: 'Aerospace and Defense',
		agriculture: 'Agriculture',
		automotive: 'Automotive',
		construction: 'Construction',
		consulting: 'Consulting',
		eCommerce: 'E-commerce',
		education: 'Education',
		energyAndUtilities: 'Energy and Utilities',
		entertainmentAndMedia: 'Entertainment and Media',
		fashionAndApparel: 'Fashion and Apparel',
		financeAndBanking: 'Finance and Banking',
		foodAndBeverage: 'Food and Beverage',
		government: 'Government',
		healthAndWellness: 'Health and Wellness',
		hospitality: 'Hospitality',
		itTechnology: 'IT/Technology',
		legalServices: 'Legal Services',
		manufacturing: 'Manufacturing',
		marketingAndAdvertising: 'Marketing and Advertising',
		nonProfitCharity: 'Non-profit/Charity',
		realEstate: 'Real Estate',
		retail: 'Retail',
		llc: 'Limited Liability Company (LLC)',
		lllp: 'Limited Liability Limited Partnership (LLLP)',
		llp: 'Limited Liability Partnership (LLP)',
		lp: 'Limited Partnership (LP)',
		serviceProvider: 'Service Provider',
		telecommunications: 'Telecommunications',
		transportationAndLogistics: 'Transportation and Logistics',
		apprenticeship: 'Apprenticeship',
		casual: 'Casual',
		contractual: 'Contractual',
		freelance: 'Freelance',
		fullTime: 'Full-time',
		internship: 'Internship',
		onDemand: 'On-demand',
		outsourcedOrOffshore: 'Outsourced or offshore',
		partTime: 'Part-time',
		permanent: 'Permanent',
		projectBased: 'Project-based',
		regular: 'Regular',
		seasonal: 'Seasonal',
		temporary: 'Temporary',
		volunteer: 'Volunteer',
		benefitCorporation: 'Benefit Corporation (B Corp)',
		cooperative: 'Cooperative',
		cooperativeCorporation: 'Cooperative Corporation',
		corporation: 'Corporation',
		familyOwnedBusiness: 'Family-Owned Business',
		franchise: 'Franchise',
		holdingCompany: 'Holding Company',
		jointVenture: 'Joint Venture',
		limitedLiabilityCompany: 'Limited Liability Company (LLC)',
		limitedLiabilityLimitedPartnership:
			'Limited Liability Limited Partnership (LLLP)',
		limitedLiabilityPartnership: 'Limited Liability Partnership (LLP)',
		limitedPartnership: 'Limited Partnership (LP)',
		nonprofitOrganization: 'Nonprofit Organization',
		partnership: 'Partnership',
		privateEquityFirm: 'Private Equity Firm',
		professionalCorporation: 'Professional Corporation (PC)',
		publiclyTradedCompany: 'Publicly Traded Company',
		sCorporation: 'S Corporation',
		socialEnterprise: 'Social Enterprise',
		soleProprietorship: 'Sole Proprietorship',
		below25: 'Below $25,000 USD',
		between50: 'Between $25,000 USD - $50,000 USD',
		between100: 'Between $50,000 USD - $100,000 USD',
		over100: 'Over $100,000 USD',

		// CORPORATE
		below50mil: 'Less than $50,000 USD',
		between100mil: 'Between $50,000 USD - $100,000 USD',
		between500mil: 'Between $100,000 USD - $500,000 USD',
		between1000mill: 'Between $500,000 USD - $1.000,000 USD',
		over1000mill: 'Over $1.000,000 USD',
		// END CORPORATE

		savingsFromSalary: 'Savings from salary',
		governmentAid: 'Government aid',
		sale: 'Sale',
		investmentsDividends: 'Investments, dividends',
		incomeFromATrust: 'Income from a trust',
		letting: 'Letting',
		inheritance: 'Inheritance',
		donation: 'Donation',
		loan: 'Loan',
		incomeFromSelfEmployment: 'Income from self-employment',
		parentsPartnerOrOther: 'Parents, partner or other',
		relativeSupport: 'Relative support',
		hedging: 'Hedging',
		speculation: 'Speculation',
		longTermInvesting: 'Long Term Investing',
		proprietaryTrading: 'Proprietary trading',
		drawSignature: 'Draw signature',
		uploadSignature: 'Upload signature',
		neverTraded: 'I have never traded',
		zeroToFiveYears: '0-5 years',
		sixToTenYears: '6-10 years',
		overTenYears: 'Over 10 years',
		below50K: 'Below $50,000 USD',
		between50KTo100K: 'Between $50,000 USD - $100,000 USD',
		between100KTo500K: 'Between $100,000 USD - $500,000 USD',
		over500K: 'Over $500,000',
		daily: 'Daily',
		weekly: 'Weekly',
		monthly: 'Monthly',
		quarterly: 'Quarterly',
		semiAnnually: 'Semi-annually',
		clientAgreement: 'Client agreement',
		ibClientAgreement: 'IB Client agreement',
		electronicTradingAgreement: 'Electronic trading agreement',
		tradingAgreement: 'Trading client agreement',
		riskDisclosure: 'Risk disclosure',
		privacyPolicy: 'Privacy policy',
		consentToDelivery: 'Consent to delivery of statements by electronic media',
		commissionAgreement: 'Commission agreement',
		termsAndConditions: 'Terms and conditions',
		swapFreeAccount: 'Swap Free Acknowledgement',
		swapFree: 'Swap free account request form',
		forex: 'Forex',
		stocks: 'Stocks',
		futures: 'Futures',
		months: {
			january: 'January',
			february: 'February',
			march: 'March',
			april: 'April',
			may: 'May',
			june: 'June',
			july: 'July',
			august: 'August',
			september: 'September',
			october: 'October',
			november: 'November',
			december: 'December',
		},
		passport: 'Passport',
		identityCard: 'Identity Card',
		residencePermit: 'Residence Permit',
		driversLicense: "Driver's License",
		utilityBill: 'Utility bill',
		bankStatement: 'Bank statement',
		certificateResidency: 'Certificate of residency',
		today: 'Today',
		lastWeek: 'Last week',
		lastMonth: 'Last month',
		last3Months: 'Last 3 months',
		last6Months: 'Last 6 months',
		costumPeriod: 'Costum period',
		lastQuarter: 'Last quarter',
		lastSemester: 'Last semester',
		lastYear: 'Last year',
		step: 'Step',
		sell: 'Sell',
		buy: 'Buy',
		transfer: 'Transfer',
		deposit: 'Deposit',
		withdrawal: 'Withdrawal',
		payout: 'Payout',
		adjustment: 'Adjustment',
		live: 'Live',
		demo: 'Demo',
	},
	//MFA
	mfa: {
		body: 'In addition to your password, set up a secondary verification method to keep your account even safer.',
		text: 'When you enable 2-step authentication, you will need to enter your password as well as a verification code sent to your email address.',
		turn: 'Turn',
		on: 'On',
		off: 'Off',
		confirm: 'Confirm',
		textTwo: 'Are you sure you want to disable the MFA?',
		yes: 'Yes',
		no: 'No',
	},

	progress: {
		title: 'Application progress',
		progress1: 'Personal details',
		progress2: 'Tax residency',
		progress3: 'Platform and currency',
		progress31: 'Account setup',
		progress4: 'Employment details',
		progress5: 'Financial details',
		progress6: 'Experience',
		progress7: 'ID type',
		progress8: 'Proof of residence',
		progress9: 'Acknowledgement',
		progress91: 'Consent and submission',
		progress92: 'Consent',
		progress10: 'Signature',
		progress11: 'Additional risk disclosure',
		progress12: 'Submit application',
		progress121: 'Submission',
		progress13: 'Secondary account holder',
		progress131: 'Secondary holder addition',
	},

	btns_: {
		back: 'Back',
		continue: 'Continue',
		cancel: 'Cancel',
		yesDelete: 'Yes, delete',
		noDelete: 'No, back',
		resendInvitations: 'Resend invitations',
		completeData: 'Complete',
		of: 'of',
		yesImSure: "Yes, I'm sure",
		submit: 'Submit',
		calculate: 'Calculate',
		contactUs: 'Contact us',
	},

	trading_tools: {
		main_title: 'Your trading tools',
		main_desc:
			'Make smarter, data-driven decisions with our powerful trading tools, designed to give you the edge in the market.',
		calculatorSuite: 'Calculator suite',
		calculatorSuiteDesc:
			'Gear up with all the must-haves for strategic trading! This powerful toolkit is designed to empower you and unravel your potential regardless of your trading level.',
		tradegatehub: 'TradeGATEHub',
		tradegatehubDesc:
			'Access free, growth-focused resources like live chat with traders and experts, live streams, and real-time market news to navigate the markets with confidence.',
		surfsup: 'Surf’s Up!',
		surfsupDesc:
			'Stay updated on the latest market developments and explore new strategies, insights, and analysis.',
		followSteps: 'To calculate, follow these simple steps:',
		step1: 'Select a market and asset',
		step2:
			'Specify, if applicable, your account’s currency, balance and the risk percentage you’re willing to take',
		step3: 'If applicable, enter the number of pips before stopping the trade',
		step4:
			'Add the pip value for your trade and click ‘Calculate’ to see your results',
		lotsize: 'Lot size calculator',
		lotsizee: 'Lot size',
		lotsizeDesc:
			'Guessing your lot size is no game. Calculate accurately and protect your profits!',
		master: 'Master calculator',
		lotsizeTooltip:
			'Guessing your lot size is no game. Calculate accurately and protect your profits!',
		masterDesc:
			'Go beyond the basics with our master calculator, featuring margins, profits, pip value, and more, to keep your strategies sharp and effective!',
		masterFooter:
			'Disclaimer: For futures and stocks, calculations are made exclusively in USD.',
		currency: 'Currency convertor',
		currencyDesc:
			'Confused by currency conversions? Simplify your trades and make informed decisions in seconds!',
		fibonacci: 'Fibonacci calculator',
		fibonacciDesc:
			'Missing key price levels? Use the Fibonacci calculator to find the best entry and exit strategies!',
		pivot: 'Pivot calculator',
		pivotPlaceh: 'Select pivot calculator',
		setParams: 'Set your parameters:',
		results: 'Results',
		market: 'Market',
		marketPlaceholder: 'Select a market',
		asset: 'Asset',
		assetPlaceholder: 'Select an asset',
		accountCurrency: 'Account currency',
		accountCurrencyPlaceholder: 'Select an account currency',
		accountbalance: 'Account balance',
		accountbalanceTooltip: 'The total amount of money in your trading account.',
		accountbalancePlaceholder: 'Enter your account balance',
		riskPerc: 'Risk percentage',
		riskPercTooltip:
			'The percentage of account balance that you are willing to risk on this trade. ',
		riskPercPlaceholder: 'Enter risk percentage (%)',
		stopLoss: 'Stop loss (pips)',
		stopLossTooltip:
			'The number of pips you are willing to allow your trade to move against you before closing it. This is your risk level in terms of market movement.',
		stopLossPlaceholder: 'Enter stop loss in pips',
		pipVal: 'Pip value',
		pipValTooltip:
			'A standard unit that measures the smallest price movement in a currency pair in Forex trading.',
		pipValPlaceholder: 'Enter the pip value',
		lots: 'Lots',
		units: 'Units',
		moneyRisk: 'Money at risk',
		forex: 'Forex & CFDs',
		cfd: 'CFDs',
		enterLotsize: 'Enter a lot size',
		margin: 'Margin',
		marginTooltip: 'The capital needed  to open and maintain a position.',
		spread: 'Spread',
		spreadTooltip:
			'The difference between the selling and the buying price of an asset.',
		comission: 'Comission',
		comissionTooltip:
			'The fee charged by Tradeview Markets for executing a trade on this account type. ',
		profit: 'Profit',
		profitTooltip: 'The net gain or loss of a trade. ',
		shortSwap: 'Short swap',
		shortSwapTooltip:
			'The swap rate applied when holding a short position (selling) overnight.',
		longSwap: 'Long swap',
		longSwapTooltip:
			'The swap rate applied when holding a long position (buying) overnight.',
		contract: 'Contract',
		chooseConv: 'Choose the conversion currencies:',
		selectCurrency: 'Select a currency',
		value: 'Value',
		highSwing: 'High swing',
		highSwingTooltip: 'The highest price point in a significant upward move.',
		lowSwing: 'Low swing',
		lowSwingTooltip: 'The lowest price point in a significant downward move.',
		customVal: 'Custom value (optional)',
		customValTooltip:
			'A particular price level or value from which to calculate the Fibonacci retracement and extension levels. Trading market',
		retracements: 'Retracements',
		retracementsTooltip:
			'These levels are calculated as percentages of the price range between a significant high and low. They may help identify potential reversal points during a price pullback.',
		extensions: 'Extensions',
		extensionsTooltip:
			'Extension levels may help in forecasting potential price targets.',
		enterAmount: 'Enter an amount',
		camarillaPivot: 'Camarilla pivot',
		demarkPivot: 'DeMark’s pivot',
		pivotPoint: 'Pivot point',
		pivotPointTooltip:
			'The amount by which the price is expected to fluctuate around a pivot point before reaching support or resistance levels.',
		woodiePivot: "Woodie's pivot",
		highprice: 'Highest price',
		lowestprice: 'Lowest price',
		closeprice: 'Closing price',
		openprice: 'Opening price',
		closepriceTooltip:
			'The closing price at the end of the selected time period.',
		openpriceTooltip:
			'The opening price at the start of the selected time period.',
		pivotPointt: 'Pivot point (P)',
		pivotPointtTooltip:
			'These amount represents price points where an asset tends to stop falling.',
		firstSupport: 'First support (S1)',
		firstSupportTooltip:
			'These amount represents price points where an asset tends to stop falling.',
		firstRes: 'First resistance (R1)',
		firstResTooltip:
			'These value indicates where price points usually stall in its rise.',
		secondSupport: 'Second support (S2)',
		secondRes: 'Second resistance (R2)',
		breakPointt: 'Breakout pivot',
		lowertarget: 'Lower target (S)',
		uppertarget: 'Upper target (R)',
		breakPointtTooltip:
			'These amount indicates when the price moves far from a key level, signaling potential momentum in a new direction.',
		lowertargetTooltip:
			'It marks a price level below the pivot, where the market could potentially move.',
		uppertargetTooltip:
			'It highlights a price level above the pivot where the market could head to.',
		masterStep1: 'Choose the market',
		masterStep2:
			'(If applicable according to your market selection) Select your account type, leverage and currency',
		masterStep3: 'Enter the asset and lot size for your trade',
		masterStep4: 'Click ‘Calculate’ to see your results',
		currencyStep1: 'Select the currency you want to convert from',
		currencyStep2: 'Enter the amount you want to exchange',
		currencyStep3: 'Choose at least one currency to convert to',
		currencyStep4: 'Click ‘Calculate’ to see your results',
		fibonacciStep1:
			'Enter the highest price of the asset for the period you want to analyze',
		fibonacciStep2:
			'Input the lowest price of the asset for the same time period',
		fibonacciStep3:
			'Fill in the custom value to further refine your analysis, this step is optional',
		pivotStep1: 'Choose the pivot calculator you wish to use',
		pivotStep2: 'Provide the information required',
		typeContract: 'Type of contract',
		stockPrice: 'Stock price',
		stockPricePlc: 'Enter the stock price',
		calculateMP: 'Calculate profit and margin',
		side: 'Side',
		enterAValue: 'Enter a value',
	},

	authErrors: {
		default: 'An unexpected error occurred. Please try again later.',

		register: {
			usernameExists:
				'This email is already registered. Please log in or use a different one.',
			invalidPassword:
				'Password must be at least 8 characters and include one lowercase, one uppercase, one number, and one special character.',
			invalidParameter:
				'Some details are incorrect or missing. Please check your information and try again.',
			aliasExists:
				'This email or phone number is already associated with another account. Please log in or use a different one.',
			limitExceeded:
				'Too many verification codes requested. Please wait a moment and try again.',
			notAuthorized:
				'We couldn’t process your signup due to an authorization issue. Please try again later.',
			codeMismatch: 'Entered code is invalid. Please check and try again.',
		},

		login: {
			userNotFound:
				'The email you entered is not registered. Please check for typos or register for a new account.',
			notAuthorized:
				'Login unsuccessful. Please check your credentials and try again. If the issue persists, contact us',
			invalidPassword:
				'Your credentials are incorrect. Please check and try again',
			codeMismatch: 'Entered code is invalid. Please check and try again.',
			userNotConfirmed:
				'Verify your account to log in. Please check your email or phone for the verification code',
			passwordResetRequired:
				'Please reset your password before logging in. Follow the reset instructions sent to your email',
			expiredCode:
				'The verification code has expired. Please request a new one and try again',
		},

		resetPass: {
			userNotFound:
				'The email you entered is not registered. Please check for typos or register for a new account',
			invalidParameter:
				'Some required details are incorrect or missing. Please review your information and try again',
			notAuthorized:
				'Authentication failed due to a missing security parameter. Please try again or contact us',
			limitExceeded:
				'Too many password reset attempts. Please wait a moment and try again',
			internalError: 'We encountered an issue. Please try again later',
			invalidLambda: 'We couldn’t process your request. Please try again later',
			invalidSmsPolicy:
				'We were unable to send an SMS for verification. Please try again later',
			codeMismatch: 'Entered code is incorrect. Please check and try again',
			expiredCode:
				'Entered code has expired. Please request a new one and try again',
			invalidPassword:
				'Password must be at least 8 characters and include one lowercase, one uppercase, one number, and one special character.',
		},
	},
}
